var _path, _g, _path2, _path3, _path4, _path5, _path6, _ellipse, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPriceicon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 82,
    viewBox: "0 0 76 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M5.41873 60.5927C-0.0923556 52.2654 -2.36163 42.4198 3.24208 33.4484C6.25234 28.6176 12.0876 26.4093 16.8577 23.5568C19.2659 23.5568 24.4065 19.0941 26.5832 17.8059C29.7787 15.9196 32.8815 13.8953 36.077 12.009C42.4217 8.28241 49.8316 4.69384 57.2415 7.5923C78.4522 15.7816 79.2858 47.2046 71.1813 64.6413C62.8452 82.5382 42.0049 85.2986 25.1938 77.6154C18.1544 74.3489 10.4204 68.0919 5.41873 60.5927Z",
    fill: "#C9ACFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0109 23.0996C56.9626 23.2437 56.8659 23.3878 56.6727 23.3878C56.5761 23.3878 56.4311 23.3397 56.3828 23.2437C56.6244 23.1476 56.8176 23.1476 57.0109 23.0996Z",
    fill: "url(#paint0_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 23.0054C59.7154 23.1975 59.5705 23.3416 59.3772 23.3416C59.184 23.3416 59.0391 23.1975 59.0391 23.0054C59.0391 22.9574 59.0391 22.9094 59.0874 22.8613C59.184 22.8613 59.3289 22.8613 59.4256 22.8613C59.5222 22.8613 59.6188 22.8613 59.7154 22.8613C59.6671 22.9094 59.7154 22.9574 59.7154 23.0054Z",
    fill: "url(#paint1_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3253 23.1968C62.277 23.2929 62.1804 23.3409 62.0354 23.3409C61.8905 23.3409 61.7456 23.1968 61.6973 23.0527C61.8905 23.1008 62.1321 23.1488 62.3253 23.1968Z",
    fill: "url(#paint2_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3522 24.6838C54.3522 24.8759 54.2072 25.02 54.014 25.02C53.8207 25.02 53.6758 24.8759 53.6758 24.6838C53.6758 24.4917 53.8207 24.3477 54.014 24.3477C54.2072 24.3477 54.3522 24.4917 54.3522 24.6838Z",
    fill: "url(#paint3_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 24.6838C57.0104 24.8759 56.8654 25.02 56.6722 25.02C56.4789 25.02 56.334 24.8759 56.334 24.6838C56.334 24.4917 56.4789 24.3477 56.6722 24.3477C56.8654 24.3477 57.0104 24.4917 57.0104 24.6838Z",
    fill: "url(#paint4_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 24.6838C59.7154 24.8759 59.5705 25.02 59.3772 25.02C59.184 25.02 59.0391 24.8759 59.0391 24.6838C59.0391 24.4917 59.184 24.3477 59.3772 24.3477C59.5222 24.3477 59.7154 24.4917 59.7154 24.6838Z",
    fill: "url(#paint5_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 24.6838C62.3736 24.8759 62.2287 25.02 62.0355 25.02C61.8422 25.02 61.6973 24.8759 61.6973 24.6838C61.6973 24.4917 61.8422 24.3477 62.0355 24.3477C62.2287 24.3477 62.3736 24.4917 62.3736 24.6838Z",
    fill: "url(#paint6_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.0299 24.6836C65.0299 24.8757 64.8849 25.0198 64.6917 25.0198C64.4985 25.0198 64.3535 24.8757 64.3535 24.6836C64.3535 24.4915 64.4985 24.3474 64.6917 24.3474C64.8849 24.3474 65.0299 24.4915 65.0299 24.6836Z",
    fill: "url(#paint7_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 26.4631C51.6471 26.6552 51.5021 26.7993 51.3089 26.7993C51.1156 26.7993 50.9707 26.6552 50.9707 26.4631C50.9707 26.271 51.1156 26.127 51.3089 26.127C51.5021 26.127 51.6471 26.271 51.6471 26.4631Z",
    fill: "url(#paint8_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.014 26.7993C54.2007 26.7993 54.3522 26.6488 54.3522 26.4631C54.3522 26.2775 54.2007 26.127 54.014 26.127C53.8272 26.127 53.6758 26.2775 53.6758 26.4631C53.6758 26.6488 53.8272 26.7993 54.014 26.7993Z",
    fill: "url(#paint9_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 26.4631C57.0104 26.6552 56.8654 26.7993 56.6722 26.7993C56.4789 26.7993 56.334 26.6552 56.334 26.4631C56.334 26.271 56.4789 26.127 56.6722 26.127C56.8654 26.127 57.0104 26.271 57.0104 26.4631Z",
    fill: "url(#paint10_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.3284 26.7993C59.5152 26.7993 59.6666 26.6488 59.6666 26.4631C59.6666 26.2775 59.5152 26.127 59.3284 26.127C59.1416 26.127 58.9902 26.2775 58.9902 26.4631C58.9902 26.6488 59.1416 26.7993 59.3284 26.7993Z",
    fill: "url(#paint11_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 26.4631C62.3736 26.6552 62.2287 26.7993 62.0355 26.7993C61.8422 26.7993 61.6973 26.6552 61.6973 26.4631C61.6973 26.271 61.8422 26.127 62.0355 26.127C62.2287 26.127 62.3736 26.271 62.3736 26.4631Z",
    fill: "url(#paint12_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M64.6917 26.7994C64.8785 26.7994 65.0299 26.6489 65.0299 26.4632C65.0299 26.2776 64.8785 26.1271 64.6917 26.1271C64.5049 26.1271 64.3535 26.2776 64.3535 26.4632C64.3535 26.6489 64.5049 26.7994 64.6917 26.7994Z",
    fill: "url(#paint13_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 26.4631C67.735 26.6552 67.59 26.7993 67.3968 26.7993C67.2035 26.7993 67.0586 26.6552 67.0586 26.4631C67.0586 26.271 67.2035 26.127 67.3968 26.127C67.5417 26.127 67.735 26.271 67.735 26.4631Z",
    fill: "url(#paint14_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9899 28.2393C48.9899 28.4314 48.845 28.5755 48.6517 28.5755C48.5551 28.5755 48.4585 28.5275 48.4102 28.4794C48.5551 28.2873 48.7 28.1433 48.7967 27.9512C48.9416 27.9992 48.9899 28.0952 48.9899 28.2393Z",
    fill: "url(#paint15_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 28.2405C51.6471 28.4326 51.5021 28.5766 51.3089 28.5766C51.1156 28.5766 50.9707 28.4326 50.9707 28.2405C50.9707 28.0484 51.1156 27.9043 51.3089 27.9043C51.5021 27.9043 51.6471 28.0484 51.6471 28.2405Z",
    fill: "url(#paint16_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.014 28.5766C54.2007 28.5766 54.3522 28.4261 54.3522 28.2405C54.3522 28.0548 54.2007 27.9043 54.014 27.9043C53.8272 27.9043 53.6758 28.0548 53.6758 28.2405C53.6758 28.4261 53.8272 28.5766 54.014 28.5766Z",
    fill: "url(#paint17_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 28.2405C57.0104 28.4326 56.8654 28.5766 56.6722 28.5766C56.4789 28.5766 56.334 28.4326 56.334 28.2405C56.334 28.0484 56.4789 27.9043 56.6722 27.9043C56.8654 27.9043 57.0104 28.0484 57.0104 28.2405Z",
    fill: "url(#paint18_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.3284 28.5766C59.5152 28.5766 59.6666 28.4261 59.6666 28.2405C59.6666 28.0548 59.5152 27.9043 59.3284 27.9043C59.1416 27.9043 58.9902 28.0548 58.9902 28.2405C58.9902 28.4261 59.1416 28.5766 59.3284 28.5766Z",
    fill: "url(#paint19_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 28.2405C62.3736 28.4326 62.2287 28.5766 62.0355 28.5766C61.8422 28.5766 61.6973 28.4326 61.6973 28.2405C61.6973 28.0484 61.8422 27.9043 62.0355 27.9043C62.2287 27.9043 62.3736 28.0484 62.3736 28.2405Z",
    fill: "url(#paint20_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M64.6917 28.5766C64.8785 28.5766 65.0299 28.4261 65.0299 28.2405C65.0299 28.0548 64.8785 27.9043 64.6917 27.9043C64.5049 27.9043 64.3535 28.0548 64.3535 28.2405C64.3535 28.4261 64.5049 28.5766 64.6917 28.5766Z",
    fill: "url(#paint21_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 28.2405C67.735 28.4326 67.59 28.5766 67.3968 28.5766C67.2035 28.5766 67.0586 28.4326 67.0586 28.2405C67.0586 28.0484 67.2035 27.9043 67.3968 27.9043C67.5417 27.9043 67.735 28.0484 67.735 28.2405Z",
    fill: "url(#paint22_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.3449 28.4326C70.2965 28.5286 70.1999 28.5766 70.055 28.5766C69.8617 28.5766 69.7168 28.4326 69.7168 28.2405C69.7168 28.0964 69.8134 27.9523 69.9584 27.9043C70.1033 28.0964 70.1999 28.2405 70.3449 28.4326Z",
    fill: "url(#paint23_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9908 30.0119C48.9908 30.204 48.8459 30.3481 48.6526 30.3481C48.4594 30.3481 48.3145 30.204 48.3145 30.0119C48.3145 29.8199 48.4594 29.6758 48.6526 29.6758C48.8459 29.6758 48.9908 29.8199 48.9908 30.0119Z",
    fill: "url(#paint24_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 30.0119C51.6471 30.204 51.5021 30.3481 51.3089 30.3481C51.1156 30.3481 50.9707 30.204 50.9707 30.0119C50.9707 29.8199 51.1156 29.6758 51.3089 29.6758C51.5021 29.6758 51.6471 29.8199 51.6471 30.0119Z",
    fill: "url(#paint25_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3522 30.0119C54.3522 30.204 54.2072 30.3481 54.014 30.3481C53.8207 30.3481 53.6758 30.204 53.6758 30.0119C53.6758 29.8199 53.8207 29.6758 54.014 29.6758C54.2072 29.6758 54.3522 29.8199 54.3522 30.0119Z",
    fill: "url(#paint26_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 30.0119C57.0104 30.204 56.8654 30.3481 56.6722 30.3481C56.4789 30.3481 56.334 30.204 56.334 30.0119C56.334 29.8199 56.4789 29.6758 56.6722 29.6758C56.8654 29.6758 57.0104 29.8199 57.0104 30.0119Z",
    fill: "url(#paint27_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 30.0119C59.7154 30.204 59.5705 30.3481 59.3772 30.3481C59.184 30.3481 59.0391 30.204 59.0391 30.0119C59.0391 29.8199 59.184 29.6758 59.3772 29.6758C59.5222 29.6758 59.7154 29.8199 59.7154 30.0119Z",
    fill: "url(#paint28_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 30.0119C62.3736 30.204 62.2287 30.3481 62.0355 30.3481C61.8422 30.3481 61.6973 30.204 61.6973 30.0119C61.6973 29.8199 61.8422 29.6758 62.0355 29.6758C62.2287 29.6758 62.3736 29.8199 62.3736 30.0119Z",
    fill: "url(#paint29_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.0299 30.0119C65.0299 30.204 64.8849 30.3481 64.6917 30.3481C64.4985 30.3481 64.3535 30.204 64.3535 30.0119C64.3535 29.8199 64.4985 29.6758 64.6917 29.6758C64.8849 29.6758 65.0299 29.8199 65.0299 30.0119Z",
    fill: "url(#paint30_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 30.0119C67.735 30.204 67.59 30.3481 67.3968 30.3481C67.2035 30.3481 67.0586 30.204 67.0586 30.0119C67.0586 29.8199 67.2035 29.6758 67.3968 29.6758C67.5417 29.6758 67.735 29.8199 67.735 30.0119Z",
    fill: "url(#paint31_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.3932 30.0119C70.3932 30.204 70.2482 30.3481 70.055 30.3481C69.8617 30.3481 69.7168 30.204 69.7168 30.0119C69.7168 29.8199 69.8617 29.6758 70.055 29.6758C70.2482 29.6758 70.3932 29.8199 70.3932 30.0119Z",
    fill: "url(#paint32_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9908 31.8378C48.9908 32.0299 48.8459 32.174 48.6526 32.174C48.4594 32.174 48.3145 32.0299 48.3145 31.8378C48.3145 31.6457 48.4594 31.5016 48.6526 31.5016C48.8459 31.4536 48.9908 31.6457 48.9908 31.8378Z",
    fill: "url(#paint33_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 31.8378C51.6471 32.0299 51.5021 32.174 51.3089 32.174C51.1156 32.174 50.9707 32.0299 50.9707 31.8378C50.9707 31.6457 51.1156 31.5016 51.3089 31.5016C51.5021 31.4536 51.6471 31.6457 51.6471 31.8378Z",
    fill: "url(#paint34_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3522 31.8378C54.3522 32.0299 54.2072 32.174 54.014 32.174C53.8207 32.174 53.6758 32.0299 53.6758 31.8378C53.6758 31.6457 53.8207 31.5016 54.014 31.5016C54.2072 31.4536 54.3522 31.6457 54.3522 31.8378Z",
    fill: "url(#paint35_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 31.8378C57.0104 32.0299 56.8654 32.174 56.6722 32.174C56.4789 32.174 56.334 32.0299 56.334 31.8378C56.334 31.6457 56.4789 31.5016 56.6722 31.5016C56.8654 31.4536 57.0104 31.6457 57.0104 31.8378Z",
    fill: "url(#paint36_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 31.8378C59.7154 32.0299 59.5705 32.174 59.3772 32.174C59.184 32.174 59.0391 32.0299 59.0391 31.8378C59.0391 31.6457 59.184 31.5016 59.3772 31.5016C59.5222 31.4536 59.7154 31.6457 59.7154 31.8378Z",
    fill: "url(#paint37_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 31.8378C62.3736 32.0299 62.2287 32.174 62.0355 32.174C61.8422 32.174 61.6973 32.0299 61.6973 31.8378C61.6973 31.6457 61.8422 31.5016 62.0355 31.5016C62.2287 31.4536 62.3736 31.6457 62.3736 31.8378Z",
    fill: "url(#paint38_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.0299 31.838C65.0299 32.0301 64.8849 32.1742 64.6917 32.1742C64.4985 32.1742 64.3535 32.0301 64.3535 31.838C64.3535 31.6459 64.4985 31.5018 64.6917 31.5018C64.8849 31.4538 65.0299 31.6459 65.0299 31.838Z",
    fill: "url(#paint39_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 31.8378C67.735 32.0299 67.59 32.174 67.3968 32.174C67.2035 32.174 67.0586 32.0299 67.0586 31.8378C67.0586 31.6457 67.2035 31.5016 67.3968 31.5016C67.5417 31.4536 67.735 31.6457 67.735 31.8378Z",
    fill: "url(#paint40_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.3932 31.8378C70.3932 32.0299 70.2482 32.174 70.055 32.174C69.8617 32.174 69.7168 32.0299 69.7168 31.8378C69.7168 31.6457 69.8617 31.5016 70.055 31.5016C70.2482 31.4536 70.3932 31.6457 70.3932 31.8378Z",
    fill: "url(#paint41_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M46.4779 33.619C46.4779 33.7631 46.3813 33.9072 46.2363 33.9552C46.2846 33.7631 46.333 33.571 46.3813 33.3789C46.4296 33.4269 46.4779 33.523 46.4779 33.619Z",
    fill: "url(#paint42_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9908 33.6194C48.9908 33.8115 48.8459 33.9555 48.6526 33.9555C48.4594 33.9555 48.3145 33.8115 48.3145 33.6194C48.3145 33.4273 48.4594 33.2832 48.6526 33.2832C48.8459 33.2832 48.9908 33.4273 48.9908 33.6194Z",
    fill: "url(#paint43_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 33.6194C51.6471 33.8115 51.5021 33.9555 51.3089 33.9555C51.1156 33.9555 50.9707 33.8115 50.9707 33.6194C50.9707 33.4273 51.1156 33.2832 51.3089 33.2832C51.5021 33.2832 51.6471 33.4273 51.6471 33.6194Z",
    fill: "url(#paint44_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.014 33.9555C54.2007 33.9555 54.3522 33.805 54.3522 33.6194C54.3522 33.4337 54.2007 33.2832 54.014 33.2832C53.8272 33.2832 53.6758 33.4337 53.6758 33.6194C53.6758 33.805 53.8272 33.9555 54.014 33.9555Z",
    fill: "url(#paint45_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 33.6194C57.0104 33.8115 56.8654 33.9555 56.6722 33.9555C56.4789 33.9555 56.334 33.8115 56.334 33.6194C56.334 33.4273 56.4789 33.2832 56.6722 33.2832C56.8654 33.2832 57.0104 33.4273 57.0104 33.6194Z",
    fill: "url(#paint46_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.3284 33.9555C59.5152 33.9555 59.6666 33.805 59.6666 33.6194C59.6666 33.4337 59.5152 33.2832 59.3284 33.2832C59.1416 33.2832 58.9902 33.4337 58.9902 33.6194C58.9902 33.805 59.1416 33.9555 59.3284 33.9555Z",
    fill: "url(#paint47_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 33.6194C62.3736 33.8115 62.2287 33.9555 62.0355 33.9555C61.8422 33.9555 61.6973 33.8115 61.6973 33.6194C61.6973 33.4273 61.8422 33.2832 62.0355 33.2832C62.2287 33.2832 62.3736 33.4273 62.3736 33.6194Z",
    fill: "url(#paint48_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M64.6917 33.9555C64.8785 33.9555 65.0299 33.805 65.0299 33.6194C65.0299 33.4337 64.8785 33.2832 64.6917 33.2832C64.5049 33.2832 64.3535 33.4337 64.3535 33.6194C64.3535 33.805 64.5049 33.9555 64.6917 33.9555Z",
    fill: "url(#paint49_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 33.6194C67.735 33.8115 67.59 33.9555 67.3968 33.9555C67.2035 33.9555 67.0586 33.8115 67.0586 33.6194C67.0586 33.4273 67.2035 33.2832 67.3968 33.2832C67.5417 33.2832 67.735 33.4273 67.735 33.6194Z",
    fill: "url(#paint50_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.3932 33.6194C70.3932 33.8115 70.2482 33.9555 70.055 33.9555C69.8617 33.9555 69.7168 33.8115 69.7168 33.6194C69.7168 33.4273 69.8617 33.2832 70.055 33.2832C70.2482 33.2832 70.3932 33.4273 70.3932 33.6194Z",
    fill: "url(#paint51_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M72.4222 33.9524C72.2289 33.9524 72.084 33.8084 72.084 33.6163C72.084 33.4722 72.1806 33.3761 72.2772 33.3281C72.3739 33.5202 72.4222 33.7123 72.4222 33.9524Z",
    fill: "url(#paint52_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M46.4778 35.3967C46.4778 35.5888 46.3328 35.7329 46.1396 35.7329C46.0913 35.7329 46.0913 35.7329 46.043 35.7329C46.043 35.4928 46.0913 35.3007 46.0913 35.0605H46.1396C46.3328 35.0605 46.4778 35.2046 46.4778 35.3967Z",
    fill: "url(#paint53_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9908 35.3967C48.9908 35.5888 48.8459 35.7329 48.6526 35.7329C48.4594 35.7329 48.3145 35.5888 48.3145 35.3967C48.3145 35.2046 48.4594 35.0605 48.6526 35.0605C48.8459 35.0605 48.9908 35.2046 48.9908 35.3967Z",
    fill: "url(#paint54_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 35.3967C51.6471 35.5888 51.5021 35.7329 51.3089 35.7329C51.1156 35.7329 50.9707 35.5888 50.9707 35.3967C50.9707 35.2046 51.1156 35.0605 51.3089 35.0605C51.5021 35.0605 51.6471 35.2046 51.6471 35.3967Z",
    fill: "url(#paint55_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3522 35.3967C54.3522 35.5888 54.2072 35.7329 54.014 35.7329C53.8207 35.7329 53.6758 35.5888 53.6758 35.3967C53.6758 35.2046 53.8207 35.0605 54.014 35.0605C54.2072 35.0605 54.3522 35.2046 54.3522 35.3967Z",
    fill: "url(#paint56_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 35.3967C57.0104 35.5888 56.8654 35.7329 56.6722 35.7329C56.4789 35.7329 56.334 35.5888 56.334 35.3967C56.334 35.2046 56.4789 35.0605 56.6722 35.0605C56.8654 35.0605 57.0104 35.2046 57.0104 35.3967Z",
    fill: "url(#paint57_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 35.3967C59.7154 35.5888 59.5705 35.7329 59.3772 35.7329C59.184 35.7329 59.0391 35.5888 59.0391 35.3967C59.0391 35.2046 59.184 35.0605 59.3772 35.0605C59.5222 35.0605 59.7154 35.2046 59.7154 35.3967Z",
    fill: "url(#paint58_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 35.3967C62.3736 35.5888 62.2287 35.7329 62.0355 35.7329C61.8422 35.7329 61.6973 35.5888 61.6973 35.3967C61.6973 35.2046 61.8422 35.0605 62.0355 35.0605C62.2287 35.0605 62.3736 35.2046 62.3736 35.3967Z",
    fill: "url(#paint59_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.0299 35.3967C65.0299 35.5888 64.8849 35.7329 64.6917 35.7329C64.4985 35.7329 64.3535 35.5888 64.3535 35.3967C64.3535 35.2046 64.4985 35.0605 64.6917 35.0605C64.8849 35.0605 65.0299 35.2046 65.0299 35.3967Z",
    fill: "url(#paint60_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 35.3967C67.735 35.5888 67.59 35.7329 67.3968 35.7329C67.2035 35.7329 67.0586 35.5888 67.0586 35.3967C67.0586 35.2046 67.2035 35.0605 67.3968 35.0605C67.5417 35.0605 67.735 35.2046 67.735 35.3967Z",
    fill: "url(#paint61_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.3932 35.3967C70.3932 35.5888 70.2482 35.7329 70.055 35.7329C69.8617 35.7329 69.7168 35.5888 69.7168 35.3967C69.7168 35.2046 69.8617 35.0605 70.055 35.0605C70.2482 35.0605 70.3932 35.2046 70.3932 35.3967Z",
    fill: "url(#paint62_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M72.6623 35.6849C72.614 35.7329 72.5657 35.7329 72.469 35.7329C72.2758 35.7329 72.1309 35.5888 72.1309 35.3967C72.1309 35.2046 72.2758 35.0605 72.469 35.0605C72.5174 35.0605 72.5657 35.0605 72.614 35.1086C72.614 35.3007 72.614 35.4928 72.6623 35.6849Z",
    fill: "url(#paint63_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M46.4778 37.1682C46.4778 37.3603 46.3328 37.5044 46.1396 37.5044H46.0913C46.0913 37.2643 46.043 37.0722 46.043 36.832C46.0913 36.832 46.0913 36.832 46.1396 36.832C46.3328 36.832 46.4778 36.9761 46.4778 37.1682Z",
    fill: "url(#paint64_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9908 37.1682C48.9908 37.3603 48.8459 37.5044 48.6526 37.5044C48.4594 37.5044 48.3145 37.3603 48.3145 37.1682C48.3145 36.9761 48.4594 36.832 48.6526 36.832C48.8459 36.832 48.9908 36.9761 48.9908 37.1682Z",
    fill: "url(#paint65_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 37.1682C51.6471 37.3603 51.5021 37.5044 51.3089 37.5044C51.1156 37.5044 50.9707 37.3603 50.9707 37.1682C50.9707 36.9761 51.1156 36.832 51.3089 36.832C51.5021 36.832 51.6471 36.9761 51.6471 37.1682Z",
    fill: "url(#paint66_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.014 37.5044C54.2007 37.5044 54.3522 37.3539 54.3522 37.1682C54.3522 36.9825 54.2007 36.832 54.014 36.832C53.8272 36.832 53.6758 36.9825 53.6758 37.1682C53.6758 37.3539 53.8272 37.5044 54.014 37.5044Z",
    fill: "url(#paint67_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 37.1682C57.0104 37.3603 56.8654 37.5044 56.6722 37.5044C56.4789 37.5044 56.334 37.3603 56.334 37.1682C56.334 36.9761 56.4789 36.832 56.6722 36.832C56.8654 36.832 57.0104 36.9761 57.0104 37.1682Z",
    fill: "url(#paint68_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.3284 37.5044C59.5152 37.5044 59.6666 37.3539 59.6666 37.1682C59.6666 36.9825 59.5152 36.832 59.3284 36.832C59.1416 36.832 58.9902 36.9825 58.9902 37.1682C58.9902 37.3539 59.1416 37.5044 59.3284 37.5044Z",
    fill: "url(#paint69_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 37.1682C62.3736 37.3603 62.2287 37.5044 62.0355 37.5044C61.8422 37.5044 61.6973 37.3603 61.6973 37.1682C61.6973 36.9761 61.8422 36.832 62.0355 36.832C62.2287 36.832 62.3736 36.9761 62.3736 37.1682Z",
    fill: "url(#paint70_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M64.6917 37.5044C64.8785 37.5044 65.0299 37.3539 65.0299 37.1682C65.0299 36.9825 64.8785 36.832 64.6917 36.832C64.5049 36.832 64.3535 36.9825 64.3535 37.1682C64.3535 37.3539 64.5049 37.5044 64.6917 37.5044Z",
    fill: "url(#paint71_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 37.1682C67.735 37.3603 67.59 37.5044 67.3968 37.5044C67.2035 37.5044 67.0586 37.3603 67.0586 37.1682C67.0586 36.9761 67.2035 36.832 67.3968 36.832C67.5417 36.832 67.735 36.9761 67.735 37.1682Z",
    fill: "url(#paint72_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.3932 37.1682C70.3932 37.3603 70.2482 37.5044 70.055 37.5044C69.8617 37.5044 69.7168 37.3603 69.7168 37.1682C69.7168 36.9761 69.8617 36.832 70.055 36.832C70.2482 36.832 70.3932 36.9761 70.3932 37.1682Z",
    fill: "url(#paint73_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M72.6623 36.8801C72.6623 37.0722 72.6623 37.2643 72.614 37.4563C72.5657 37.4563 72.5174 37.5044 72.469 37.5044C72.2758 37.5044 72.1309 37.3603 72.1309 37.1682C72.1309 36.9761 72.2758 36.832 72.469 36.832C72.5174 36.832 72.614 36.8801 72.6623 36.8801Z",
    fill: "url(#paint74_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M46.4774 38.9483C46.4774 39.0444 46.4291 39.1404 46.3324 39.2364C46.2841 39.0443 46.2358 38.8523 46.1875 38.6602C46.3324 38.6602 46.4774 38.8042 46.4774 38.9483Z",
    fill: "url(#paint75_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9908 38.9495C48.9908 39.1416 48.8459 39.2856 48.6526 39.2856C48.4594 39.2856 48.3145 39.1416 48.3145 38.9495C48.3145 38.7574 48.4594 38.6133 48.6526 38.6133C48.8459 38.6133 48.9908 38.7574 48.9908 38.9495Z",
    fill: "url(#paint76_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 38.9495C51.6471 39.1416 51.5021 39.2856 51.3089 39.2856C51.1156 39.2856 50.9707 39.1416 50.9707 38.9495C50.9707 38.7574 51.1156 38.6133 51.3089 38.6133C51.5021 38.6133 51.6471 38.7574 51.6471 38.9495Z",
    fill: "url(#paint77_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3522 38.9495C54.3522 39.1416 54.2072 39.2856 54.014 39.2856C53.8207 39.2856 53.6758 39.1416 53.6758 38.9495C53.6758 38.7574 53.8207 38.6133 54.014 38.6133C54.2072 38.6133 54.3522 38.7574 54.3522 38.9495Z",
    fill: "url(#paint78_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 38.9495C57.0104 39.1416 56.8654 39.2856 56.6722 39.2856C56.4789 39.2856 56.334 39.1416 56.334 38.9495C56.334 38.7574 56.4789 38.6133 56.6722 38.6133C56.8654 38.6133 57.0104 38.7574 57.0104 38.9495Z",
    fill: "url(#paint79_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 38.9495C59.7154 39.1416 59.5705 39.2856 59.3772 39.2856C59.184 39.2856 59.0391 39.1416 59.0391 38.9495C59.0391 38.7574 59.184 38.6133 59.3772 38.6133C59.5222 38.6133 59.7154 38.7574 59.7154 38.9495Z",
    fill: "url(#paint80_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 38.9495C62.3736 39.1416 62.2287 39.2856 62.0355 39.2856C61.8422 39.2856 61.6973 39.1416 61.6973 38.9495C61.6973 38.7574 61.8422 38.6133 62.0355 38.6133C62.2287 38.6133 62.3736 38.7574 62.3736 38.9495Z",
    fill: "url(#paint81_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.0299 38.9495C65.0299 39.1416 64.8849 39.2856 64.6917 39.2856C64.4985 39.2856 64.3535 39.1416 64.3535 38.9495C64.3535 38.7574 64.4985 38.6133 64.6917 38.6133C64.8849 38.6133 65.0299 38.7574 65.0299 38.9495Z",
    fill: "url(#paint82_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 38.9495C67.735 39.1416 67.59 39.2856 67.3968 39.2856C67.2035 39.2856 67.0586 39.1416 67.0586 38.9495C67.0586 38.7574 67.2035 38.6133 67.3968 38.6133C67.5417 38.6133 67.735 38.7574 67.735 38.9495Z",
    fill: "url(#paint83_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.3932 38.9495C70.3932 39.1416 70.2482 39.2856 70.055 39.2856C69.8617 39.2856 69.7168 39.1416 69.7168 38.9495C69.7168 38.7574 69.8617 38.6133 70.055 38.6133C70.2482 38.6133 70.3932 38.7574 70.3932 38.9495Z",
    fill: "url(#paint84_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M72.469 38.6133C72.4207 38.8534 72.3724 39.0455 72.3241 39.2856C72.1792 39.2376 72.1309 39.0935 72.1309 38.9495C72.1309 38.7574 72.2758 38.6133 72.469 38.6133Z",
    fill: "url(#paint85_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9908 40.7756C48.9908 40.9677 48.8459 41.1118 48.6526 41.1118C48.4594 41.1118 48.3145 40.9677 48.3145 40.7756C48.3145 40.5835 48.4594 40.4395 48.6526 40.4395C48.8459 40.4395 48.9908 40.5835 48.9908 40.7756Z",
    fill: "url(#paint86_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 40.7756C51.6471 40.9677 51.5021 41.1118 51.3089 41.1118C51.1156 41.1118 50.9707 40.9677 50.9707 40.7756C50.9707 40.5835 51.1156 40.4395 51.3089 40.4395C51.5021 40.4395 51.6471 40.5835 51.6471 40.7756Z",
    fill: "url(#paint87_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3522 40.7756C54.3522 40.9677 54.2072 41.1118 54.014 41.1118C53.8207 41.1118 53.6758 40.9677 53.6758 40.7756C53.6758 40.5835 53.8207 40.4395 54.014 40.4395C54.2072 40.4395 54.3522 40.5835 54.3522 40.7756Z",
    fill: "url(#paint88_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 40.7756C57.0104 40.9677 56.8654 41.1118 56.6722 41.1118C56.4789 41.1118 56.334 40.9677 56.334 40.7756C56.334 40.5835 56.4789 40.4395 56.6722 40.4395C56.8654 40.4395 57.0104 40.5835 57.0104 40.7756Z",
    fill: "url(#paint89_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 40.7756C59.7154 40.9677 59.5705 41.1118 59.3772 41.1118C59.184 41.1118 59.0391 40.9677 59.0391 40.7756C59.0391 40.5835 59.184 40.4395 59.3772 40.4395C59.5222 40.4395 59.7154 40.5835 59.7154 40.7756Z",
    fill: "url(#paint90_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 40.7756C62.3736 40.9677 62.2287 41.1118 62.0355 41.1118C61.8422 41.1118 61.6973 40.9677 61.6973 40.7756C61.6973 40.5835 61.8422 40.4395 62.0355 40.4395C62.2287 40.4395 62.3736 40.5835 62.3736 40.7756Z",
    fill: "url(#paint91_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.0299 40.7756C65.0299 40.9677 64.8849 41.1118 64.6917 41.1118C64.4985 41.1118 64.3535 40.9677 64.3535 40.7756C64.3535 40.5835 64.4985 40.4395 64.6917 40.4395C64.8849 40.4395 65.0299 40.5835 65.0299 40.7756Z",
    fill: "url(#paint92_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 40.7756C67.735 40.9677 67.59 41.1118 67.3968 41.1118C67.2035 41.1118 67.0586 40.9677 67.0586 40.7756C67.0586 40.5835 67.2035 40.4395 67.3968 40.4395C67.5417 40.4395 67.735 40.5835 67.735 40.7756Z",
    fill: "url(#paint93_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.3932 40.7756C70.3932 40.9677 70.2482 41.1118 70.055 41.1118C69.8617 41.1118 69.7168 40.9677 69.7168 40.7756C69.7168 40.5835 69.8617 40.4395 70.055 40.4395C70.2482 40.4395 70.3932 40.5835 70.3932 40.7756Z",
    fill: "url(#paint94_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9908 42.5491C48.9908 42.7412 48.8459 42.8852 48.6526 42.8852C48.4594 42.8852 48.3145 42.7412 48.3145 42.5491C48.3145 42.357 48.4594 42.2129 48.6526 42.2129C48.8459 42.2129 48.9908 42.357 48.9908 42.5491Z",
    fill: "url(#paint95_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 42.5491C51.6471 42.7412 51.5021 42.8852 51.3089 42.8852C51.1156 42.8852 50.9707 42.7412 50.9707 42.5491C50.9707 42.357 51.1156 42.2129 51.3089 42.2129C51.5021 42.2129 51.6471 42.357 51.6471 42.5491Z",
    fill: "url(#paint96_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3522 42.5491C54.3522 42.7412 54.2072 42.8852 54.014 42.8852C53.8207 42.8852 53.6758 42.7412 53.6758 42.5491C53.6758 42.357 53.8207 42.2129 54.014 42.2129C54.2072 42.2129 54.3522 42.357 54.3522 42.5491Z",
    fill: "url(#paint97_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 42.5491C57.0104 42.7412 56.8654 42.8852 56.6722 42.8852C56.4789 42.8852 56.334 42.7412 56.334 42.5491C56.334 42.357 56.4789 42.2129 56.6722 42.2129C56.8654 42.2129 57.0104 42.357 57.0104 42.5491Z",
    fill: "url(#paint98_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 42.5491C59.7154 42.7412 59.5705 42.8852 59.3772 42.8852C59.184 42.8852 59.0391 42.7412 59.0391 42.5491C59.0391 42.357 59.184 42.2129 59.3772 42.2129C59.5222 42.2129 59.7154 42.357 59.7154 42.5491Z",
    fill: "url(#paint99_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 42.5491C62.3736 42.7412 62.2287 42.8852 62.0355 42.8852C61.8422 42.8852 61.6973 42.7412 61.6973 42.5491C61.6973 42.357 61.8422 42.2129 62.0355 42.2129C62.2287 42.2129 62.3736 42.357 62.3736 42.5491Z",
    fill: "url(#paint100_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.0299 42.5493C65.0299 42.7414 64.8849 42.8855 64.6917 42.8855C64.4985 42.8855 64.3535 42.7414 64.3535 42.5493C64.3535 42.3572 64.4985 42.2131 64.6917 42.2131C64.8849 42.2131 65.0299 42.3572 65.0299 42.5493Z",
    fill: "url(#paint101_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 42.5491C67.735 42.7412 67.59 42.8852 67.3968 42.8852C67.2035 42.8852 67.0586 42.7412 67.0586 42.5491C67.0586 42.357 67.2035 42.2129 67.3968 42.2129C67.5417 42.2129 67.735 42.357 67.735 42.5491Z",
    fill: "url(#paint102_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.3932 42.5491C70.3932 42.7412 70.2482 42.8852 70.055 42.8852C69.8617 42.8852 69.7168 42.7412 69.7168 42.5491C69.7168 42.357 69.8617 42.2129 70.055 42.2129C70.2482 42.2129 70.3932 42.357 70.3932 42.5491Z",
    fill: "url(#paint103_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9894 44.3284C48.9894 44.4724 48.8928 44.6165 48.7478 44.6645C48.6029 44.5205 48.5063 44.3284 48.3613 44.1363C48.4096 44.0402 48.5063 43.9922 48.6512 43.9922C48.8445 43.9922 48.9894 44.1363 48.9894 44.3284Z",
    fill: "url(#paint104_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 44.3284C51.6471 44.5205 51.5021 44.6645 51.3089 44.6645C51.1156 44.6645 50.9707 44.5205 50.9707 44.3284C50.9707 44.1363 51.1156 43.9922 51.3089 43.9922C51.5021 43.9922 51.6471 44.1363 51.6471 44.3284Z",
    fill: "url(#paint105_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3522 44.3284C54.3522 44.5205 54.2072 44.6645 54.014 44.6645C53.8207 44.6645 53.6758 44.5205 53.6758 44.3284C53.6758 44.1363 53.8207 43.9922 54.014 43.9922C54.2072 43.9922 54.3522 44.1363 54.3522 44.3284Z",
    fill: "url(#paint106_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 44.3284C57.0104 44.5205 56.8654 44.6645 56.6722 44.6645C56.4789 44.6645 56.334 44.5205 56.334 44.3284C56.334 44.1363 56.4789 43.9922 56.6722 43.9922C56.8654 43.9922 57.0104 44.1363 57.0104 44.3284Z",
    fill: "url(#paint107_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 44.3284C59.7154 44.5205 59.5705 44.6645 59.3772 44.6645C59.184 44.6645 59.0391 44.5205 59.0391 44.3284C59.0391 44.1363 59.184 43.9922 59.3772 43.9922C59.5222 43.9922 59.7154 44.1363 59.7154 44.3284Z",
    fill: "url(#paint108_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 44.3284C62.3736 44.5205 62.2287 44.6645 62.0355 44.6645C61.8422 44.6645 61.6973 44.5205 61.6973 44.3284C61.6973 44.1363 61.8422 43.9922 62.0355 43.9922C62.2287 43.9922 62.3736 44.1363 62.3736 44.3284Z",
    fill: "url(#paint109_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.0299 44.3284C65.0299 44.5205 64.8849 44.6645 64.6917 44.6645C64.4985 44.6645 64.3535 44.5205 64.3535 44.3284C64.3535 44.1363 64.4985 43.9922 64.6917 43.9922C64.8849 43.9922 65.0299 44.1363 65.0299 44.3284Z",
    fill: "url(#paint110_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 44.3284C67.735 44.5205 67.59 44.6645 67.3968 44.6645C67.2035 44.6645 67.0586 44.5205 67.0586 44.3284C67.0586 44.1363 67.2035 43.9922 67.3968 43.9922C67.5417 43.9922 67.735 44.1363 67.735 44.3284Z",
    fill: "url(#paint111_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.3449 44.1843C70.2482 44.3284 70.1033 44.5205 70.0067 44.6645C69.8134 44.6645 69.7168 44.5205 69.7168 44.3284C69.7168 44.1363 69.8617 43.9922 70.055 43.9922C70.1999 43.9922 70.2965 44.0882 70.3449 44.1843Z",
    fill: "url(#paint112_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 46.1057C51.6471 46.2978 51.5021 46.4419 51.3089 46.4419C51.1156 46.4419 50.9707 46.2978 50.9707 46.1057C50.9707 45.9136 51.1156 45.7695 51.3089 45.7695C51.5021 45.7695 51.6471 45.9136 51.6471 46.1057Z",
    fill: "url(#paint113_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3522 46.1057C54.3522 46.2978 54.2072 46.4419 54.014 46.4419C53.8207 46.4419 53.6758 46.2978 53.6758 46.1057C53.6758 45.9136 53.8207 45.7695 54.014 45.7695C54.2072 45.7695 54.3522 45.9136 54.3522 46.1057Z",
    fill: "url(#paint114_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 46.1057C57.0104 46.2978 56.8654 46.4419 56.6722 46.4419C56.4789 46.4419 56.334 46.2978 56.334 46.1057C56.334 45.9136 56.4789 45.7695 56.6722 45.7695C56.8654 45.7695 57.0104 45.9136 57.0104 46.1057Z",
    fill: "url(#paint115_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 46.1057C59.7154 46.2978 59.5705 46.4419 59.3772 46.4419C59.184 46.4419 59.0391 46.2978 59.0391 46.1057C59.0391 45.9136 59.184 45.7695 59.3772 45.7695C59.5222 45.7695 59.7154 45.9136 59.7154 46.1057Z",
    fill: "url(#paint116_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 46.1057C62.3736 46.2978 62.2287 46.4419 62.0355 46.4419C61.8422 46.4419 61.6973 46.2978 61.6973 46.1057C61.6973 45.9136 61.8422 45.7695 62.0355 45.7695C62.2287 45.7695 62.3736 45.9136 62.3736 46.1057Z",
    fill: "url(#paint117_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.0299 46.1057C65.0299 46.2978 64.8849 46.4419 64.6917 46.4419C64.4985 46.4419 64.3535 46.2978 64.3535 46.1057C64.3535 45.9136 64.4985 45.7695 64.6917 45.7695C64.8849 45.7695 65.0299 45.9136 65.0299 46.1057Z",
    fill: "url(#paint118_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 46.1057C67.735 46.2978 67.59 46.4419 67.3968 46.4419C67.2035 46.4419 67.0586 46.2978 67.0586 46.1057C67.0586 45.9136 67.2035 45.7695 67.3968 45.7695C67.5417 45.7695 67.735 45.9136 67.735 46.1057Z",
    fill: "url(#paint119_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.014 48.2661C54.2007 48.2661 54.3522 48.1156 54.3522 47.9299C54.3522 47.7443 54.2007 47.5938 54.014 47.5938C53.8272 47.5938 53.6758 47.7443 53.6758 47.9299C53.6758 48.1156 53.8272 48.2661 54.014 48.2661Z",
    fill: "url(#paint120_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 47.9296C57.0104 48.1217 56.8654 48.2657 56.6722 48.2657C56.4789 48.2657 56.334 48.1217 56.334 47.9296C56.334 47.7375 56.4789 47.5934 56.6722 47.5934C56.8654 47.5454 57.0104 47.7375 57.0104 47.9296Z",
    fill: "url(#paint121_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.3284 48.2661C59.5152 48.2661 59.6666 48.1156 59.6666 47.9299C59.6666 47.7443 59.5152 47.5938 59.3284 47.5938C59.1416 47.5938 58.9902 47.7443 58.9902 47.9299C58.9902 48.1156 59.1416 48.2661 59.3284 48.2661Z",
    fill: "url(#paint122_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 47.9296C62.3736 48.1217 62.2287 48.2657 62.0355 48.2657C61.8422 48.2657 61.6973 48.1217 61.6973 47.9296C61.6973 47.7375 61.8422 47.5934 62.0355 47.5934C62.2287 47.5454 62.3736 47.7375 62.3736 47.9296Z",
    fill: "url(#paint123_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M64.6917 48.2661C64.8785 48.2661 65.0299 48.1156 65.0299 47.9299C65.0299 47.7443 64.8785 47.5938 64.6917 47.5938C64.5049 47.5938 64.3535 47.7443 64.3535 47.9299C64.3535 48.1156 64.5049 48.2661 64.6917 48.2661Z",
    fill: "url(#paint124_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0099 49.5612C56.8167 49.5132 56.6235 49.5132 56.4785 49.4652C56.5268 49.4172 56.6235 49.3691 56.7201 49.3691C56.8167 49.3691 56.9616 49.4652 57.0099 49.5612Z",
    fill: "url(#paint125_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 49.7053C59.7154 49.7533 59.7154 49.7533 59.7154 49.8014C59.6188 49.8014 59.5222 49.8014 59.4256 49.8014C59.2806 49.8014 59.184 49.8014 59.0391 49.8014C59.0391 49.7533 59.0391 49.7533 59.0391 49.7053C59.0391 49.5132 59.184 49.3691 59.3772 49.3691C59.5222 49.3691 59.7154 49.5132 59.7154 49.7053Z",
    fill: "url(#paint126_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.277 49.4683C62.0838 49.5163 61.8905 49.5643 61.6973 49.5643C61.7456 49.4203 61.8905 49.3242 62.0355 49.3242C62.1321 49.3722 62.2287 49.4203 62.277 49.4683Z",
    fill: "url(#paint127_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M46.4778 37.1682C46.4778 37.3603 46.3328 37.5044 46.1396 37.5044H46.0913C46.0913 37.2643 46.043 37.0722 46.043 36.832C46.0913 36.832 46.0913 36.832 46.1396 36.832C46.3328 36.832 46.4778 36.9761 46.4778 37.1682Z",
    fill: "url(#paint128_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M46.4778 35.3967C46.4778 35.5888 46.3328 35.7329 46.1396 35.7329C46.0913 35.7329 46.0913 35.7329 46.043 35.7329C46.043 35.4928 46.0913 35.3007 46.0913 35.0605H46.1396C46.3328 35.0605 46.4778 35.2046 46.4778 35.3967Z",
    fill: "url(#paint129_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M46.4774 38.9483C46.4774 39.0444 46.4291 39.1404 46.3324 39.2364C46.2841 39.0443 46.2358 38.8523 46.1875 38.6602C46.3324 38.6602 46.4774 38.8042 46.4774 38.9483Z",
    fill: "url(#paint130_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M46.333 33.3281C46.4296 33.3761 46.4779 33.4722 46.4779 33.5682C46.4779 33.7123 46.3813 33.8564 46.2363 33.9044C46.2363 33.7123 46.2846 33.5202 46.333 33.3281Z",
    fill: "url(#paint131_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9908 42.5491C48.9908 42.7412 48.8459 42.8852 48.6526 42.8852C48.4594 42.8852 48.3145 42.7412 48.3145 42.5491C48.3145 42.357 48.4594 42.2129 48.6526 42.2129C48.8459 42.2129 48.9908 42.357 48.9908 42.5491Z",
    fill: "url(#paint132_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9908 40.7756C48.9908 40.9677 48.8459 41.1118 48.6526 41.1118C48.4594 41.1118 48.3145 40.9677 48.3145 40.7756C48.3145 40.5835 48.4594 40.4395 48.6526 40.4395C48.8459 40.4395 48.9908 40.5835 48.9908 40.7756Z",
    fill: "url(#paint133_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9908 38.9495C48.9908 39.1416 48.8459 39.2856 48.6526 39.2856C48.4594 39.2856 48.3145 39.1416 48.3145 38.9495C48.3145 38.7574 48.4594 38.6133 48.6526 38.6133C48.8459 38.6133 48.9908 38.7574 48.9908 38.9495Z",
    fill: "url(#paint134_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9908 37.1682C48.9908 37.3603 48.8459 37.5044 48.6526 37.5044C48.4594 37.5044 48.3145 37.3603 48.3145 37.1682C48.3145 36.9761 48.4594 36.832 48.6526 36.832C48.8459 36.832 48.9908 36.9761 48.9908 37.1682Z",
    fill: "url(#paint135_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9908 35.3967C48.9908 35.5888 48.8459 35.7329 48.6526 35.7329C48.4594 35.7329 48.3145 35.5888 48.3145 35.3967C48.3145 35.2046 48.4594 35.0605 48.6526 35.0605C48.8459 35.0605 48.9908 35.2046 48.9908 35.3967Z",
    fill: "url(#paint136_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9908 33.6194C48.9908 33.8115 48.8459 33.9555 48.6526 33.9555C48.4594 33.9555 48.3145 33.8115 48.3145 33.6194C48.3145 33.4273 48.4594 33.2832 48.6526 33.2832C48.8459 33.2832 48.9908 33.4273 48.9908 33.6194Z",
    fill: "url(#paint137_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9908 31.8378C48.9908 32.0299 48.8459 32.174 48.6526 32.174C48.4594 32.174 48.3145 32.0299 48.3145 31.8378C48.3145 31.6457 48.4594 31.5016 48.6526 31.5016C48.8459 31.4536 48.9908 31.6457 48.9908 31.8378Z",
    fill: "url(#paint138_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9908 30.0119C48.9908 30.204 48.8459 30.3481 48.6526 30.3481C48.4594 30.3481 48.3145 30.204 48.3145 30.0119C48.3145 29.8199 48.4594 29.6758 48.6526 29.6758C48.8459 29.6758 48.9908 29.8199 48.9908 30.0119Z",
    fill: "url(#paint139_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9894 44.3284C48.9894 44.4724 48.8928 44.6165 48.7478 44.6645C48.6029 44.5205 48.5063 44.3284 48.3613 44.1363C48.4096 44.0402 48.5063 43.9922 48.6512 43.9922C48.8445 43.9922 48.9894 44.1363 48.9894 44.3284Z",
    fill: "url(#paint140_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9899 28.2393C48.9899 28.4314 48.845 28.5755 48.6517 28.5755C48.5551 28.5755 48.4585 28.5275 48.4102 28.4794C48.5551 28.2873 48.7 28.1433 48.7967 27.9512C48.9416 27.9992 48.9899 28.0952 48.9899 28.2393Z",
    fill: "url(#paint141_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 46.1057C51.6471 46.2978 51.5021 46.4419 51.3089 46.4419C51.1156 46.4419 50.9707 46.2978 50.9707 46.1057C50.9707 45.9136 51.1156 45.7695 51.3089 45.7695C51.5021 45.7695 51.6471 45.9136 51.6471 46.1057Z",
    fill: "url(#paint142_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 44.3284C51.6471 44.5205 51.5021 44.6645 51.3089 44.6645C51.1156 44.6645 50.9707 44.5205 50.9707 44.3284C50.9707 44.1363 51.1156 43.9922 51.3089 43.9922C51.5021 43.9922 51.6471 44.1363 51.6471 44.3284Z",
    fill: "url(#paint143_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 42.5491C51.6471 42.7412 51.5021 42.8852 51.3089 42.8852C51.1156 42.8852 50.9707 42.7412 50.9707 42.5491C50.9707 42.357 51.1156 42.2129 51.3089 42.2129C51.5021 42.2129 51.6471 42.357 51.6471 42.5491Z",
    fill: "url(#paint144_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 40.7756C51.6471 40.9677 51.5021 41.1118 51.3089 41.1118C51.1156 41.1118 50.9707 40.9677 50.9707 40.7756C50.9707 40.5835 51.1156 40.4395 51.3089 40.4395C51.5021 40.4395 51.6471 40.5835 51.6471 40.7756Z",
    fill: "url(#paint145_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 38.9495C51.6471 39.1416 51.5021 39.2856 51.3089 39.2856C51.1156 39.2856 50.9707 39.1416 50.9707 38.9495C50.9707 38.7574 51.1156 38.6133 51.3089 38.6133C51.5021 38.6133 51.6471 38.7574 51.6471 38.9495Z",
    fill: "url(#paint146_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 37.1682C51.6471 37.3603 51.5021 37.5044 51.3089 37.5044C51.1156 37.5044 50.9707 37.3603 50.9707 37.1682C50.9707 36.9761 51.1156 36.832 51.3089 36.832C51.5021 36.832 51.6471 36.9761 51.6471 37.1682Z",
    fill: "url(#paint147_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 35.3967C51.6471 35.5888 51.5021 35.7329 51.3089 35.7329C51.1156 35.7329 50.9707 35.5888 50.9707 35.3967C50.9707 35.2046 51.1156 35.0605 51.3089 35.0605C51.5021 35.0605 51.6471 35.2046 51.6471 35.3967Z",
    fill: "url(#paint148_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 33.6194C51.6471 33.8115 51.5021 33.9555 51.3089 33.9555C51.1156 33.9555 50.9707 33.8115 50.9707 33.6194C50.9707 33.4273 51.1156 33.2832 51.3089 33.2832C51.5021 33.2832 51.6471 33.4273 51.6471 33.6194Z",
    fill: "url(#paint149_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 31.8378C51.6471 32.0299 51.5021 32.174 51.3089 32.174C51.1156 32.174 50.9707 32.0299 50.9707 31.8378C50.9707 31.6457 51.1156 31.5016 51.3089 31.5016C51.5021 31.4536 51.6471 31.6457 51.6471 31.8378Z",
    fill: "url(#paint150_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 30.0119C51.6471 30.204 51.5021 30.3481 51.3089 30.3481C51.1156 30.3481 50.9707 30.204 50.9707 30.0119C50.9707 29.8199 51.1156 29.6758 51.3089 29.6758C51.5021 29.6758 51.6471 29.8199 51.6471 30.0119Z",
    fill: "url(#paint151_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 28.2405C51.6471 28.4326 51.5021 28.5766 51.3089 28.5766C51.1156 28.5766 50.9707 28.4326 50.9707 28.2405C50.9707 28.0484 51.1156 27.9043 51.3089 27.9043C51.5021 27.9043 51.6471 28.0484 51.6471 28.2405Z",
    fill: "url(#paint152_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.6471 26.4631C51.6471 26.6552 51.5021 26.7993 51.3089 26.7993C51.1156 26.7993 50.9707 26.6552 50.9707 26.4631C50.9707 26.271 51.1156 26.127 51.3089 26.127C51.5021 26.127 51.6471 26.271 51.6471 26.4631Z",
    fill: "url(#paint153_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.014 48.2661C54.2007 48.2661 54.3522 48.1156 54.3522 47.9299C54.3522 47.7443 54.2007 47.5938 54.014 47.5938C53.8272 47.5938 53.6758 47.7443 53.6758 47.9299C53.6758 48.1156 53.8272 48.2661 54.014 48.2661Z",
    fill: "url(#paint154_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3522 46.1057C54.3522 46.2978 54.2072 46.4419 54.014 46.4419C53.8207 46.4419 53.6758 46.2978 53.6758 46.1057C53.6758 45.9136 53.8207 45.7695 54.014 45.7695C54.2072 45.7695 54.3522 45.9136 54.3522 46.1057Z",
    fill: "url(#paint155_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3522 44.3284C54.3522 44.5205 54.2072 44.6645 54.014 44.6645C53.8207 44.6645 53.6758 44.5205 53.6758 44.3284C53.6758 44.1363 53.8207 43.9922 54.014 43.9922C54.2072 43.9922 54.3522 44.1363 54.3522 44.3284Z",
    fill: "url(#paint156_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3522 42.5491C54.3522 42.7412 54.2072 42.8852 54.014 42.8852C53.8207 42.8852 53.6758 42.7412 53.6758 42.5491C53.6758 42.357 53.8207 42.2129 54.014 42.2129C54.2072 42.2129 54.3522 42.357 54.3522 42.5491Z",
    fill: "url(#paint157_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3522 40.7756C54.3522 40.9677 54.2072 41.1118 54.014 41.1118C53.8207 41.1118 53.6758 40.9677 53.6758 40.7756C53.6758 40.5835 53.8207 40.4395 54.014 40.4395C54.2072 40.4395 54.3522 40.5835 54.3522 40.7756Z",
    fill: "url(#paint158_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3522 38.9495C54.3522 39.1416 54.2072 39.2856 54.014 39.2856C53.8207 39.2856 53.6758 39.1416 53.6758 38.9495C53.6758 38.7574 53.8207 38.6133 54.014 38.6133C54.2072 38.6133 54.3522 38.7574 54.3522 38.9495Z",
    fill: "url(#paint159_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.014 37.5044C54.2007 37.5044 54.3522 37.3539 54.3522 37.1682C54.3522 36.9825 54.2007 36.832 54.014 36.832C53.8272 36.832 53.6758 36.9825 53.6758 37.1682C53.6758 37.3539 53.8272 37.5044 54.014 37.5044Z",
    fill: "url(#paint160_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3522 35.3967C54.3522 35.5888 54.2072 35.7329 54.014 35.7329C53.8207 35.7329 53.6758 35.5888 53.6758 35.3967C53.6758 35.2046 53.8207 35.0605 54.014 35.0605C54.2072 35.0605 54.3522 35.2046 54.3522 35.3967Z",
    fill: "url(#paint161_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.014 33.9555C54.2007 33.9555 54.3522 33.805 54.3522 33.6194C54.3522 33.4337 54.2007 33.2832 54.014 33.2832C53.8272 33.2832 53.6758 33.4337 53.6758 33.6194C53.6758 33.805 53.8272 33.9555 54.014 33.9555Z",
    fill: "url(#paint162_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3522 31.8378C54.3522 32.0299 54.2072 32.174 54.014 32.174C53.8207 32.174 53.6758 32.0299 53.6758 31.8378C53.6758 31.6457 53.8207 31.5016 54.014 31.5016C54.2072 31.4536 54.3522 31.6457 54.3522 31.8378Z",
    fill: "url(#paint163_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3522 30.0119C54.3522 30.204 54.2072 30.3481 54.014 30.3481C53.8207 30.3481 53.6758 30.204 53.6758 30.0119C53.6758 29.8199 53.8207 29.6758 54.014 29.6758C54.2072 29.6758 54.3522 29.8199 54.3522 30.0119Z",
    fill: "url(#paint164_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.014 28.5766C54.2007 28.5766 54.3522 28.4261 54.3522 28.2405C54.3522 28.0548 54.2007 27.9043 54.014 27.9043C53.8272 27.9043 53.6758 28.0548 53.6758 28.2405C53.6758 28.4261 53.8272 28.5766 54.014 28.5766Z",
    fill: "url(#paint165_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.014 26.7993C54.2007 26.7993 54.3522 26.6488 54.3522 26.4631C54.3522 26.2775 54.2007 26.127 54.014 26.127C53.8272 26.127 53.6758 26.2775 53.6758 26.4631C53.6758 26.6488 53.8272 26.7993 54.014 26.7993Z",
    fill: "url(#paint166_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3522 24.6838C54.3522 24.8759 54.2072 25.02 54.014 25.02C53.8207 25.02 53.6758 24.8759 53.6758 24.6838C53.6758 24.4917 53.8207 24.3477 54.014 24.3477C54.2072 24.3477 54.3522 24.4917 54.3522 24.6838Z",
    fill: "url(#paint167_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M56.6727 23.3409C56.5761 23.3409 56.4311 23.2929 56.3828 23.1968C56.5761 23.1488 56.7693 23.1008 57.0109 23.0527C56.9626 23.2448 56.8659 23.3409 56.6727 23.3409Z",
    fill: "url(#paint168_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 47.9296C57.0104 48.1217 56.8654 48.2657 56.6722 48.2657C56.4789 48.2657 56.334 48.1217 56.334 47.9296C56.334 47.7375 56.4789 47.5934 56.6722 47.5934C56.8654 47.5454 57.0104 47.7375 57.0104 47.9296Z",
    fill: "url(#paint169_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 46.1057C57.0104 46.2978 56.8654 46.4419 56.6722 46.4419C56.4789 46.4419 56.334 46.2978 56.334 46.1057C56.334 45.9136 56.4789 45.7695 56.6722 45.7695C56.8654 45.7695 57.0104 45.9136 57.0104 46.1057Z",
    fill: "url(#paint170_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 44.3284C57.0104 44.5205 56.8654 44.6645 56.6722 44.6645C56.4789 44.6645 56.334 44.5205 56.334 44.3284C56.334 44.1363 56.4789 43.9922 56.6722 43.9922C56.8654 43.9922 57.0104 44.1363 57.0104 44.3284Z",
    fill: "url(#paint171_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 42.5491C57.0104 42.7412 56.8654 42.8852 56.6722 42.8852C56.4789 42.8852 56.334 42.7412 56.334 42.5491C56.334 42.357 56.4789 42.2129 56.6722 42.2129C56.8654 42.2129 57.0104 42.357 57.0104 42.5491Z",
    fill: "url(#paint172_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 40.7756C57.0104 40.9677 56.8654 41.1118 56.6722 41.1118C56.4789 41.1118 56.334 40.9677 56.334 40.7756C56.334 40.5835 56.4789 40.4395 56.6722 40.4395C56.8654 40.4395 57.0104 40.5835 57.0104 40.7756Z",
    fill: "url(#paint173_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 38.9495C57.0104 39.1416 56.8654 39.2856 56.6722 39.2856C56.4789 39.2856 56.334 39.1416 56.334 38.9495C56.334 38.7574 56.4789 38.6133 56.6722 38.6133C56.8654 38.6133 57.0104 38.7574 57.0104 38.9495Z",
    fill: "url(#paint174_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 37.1682C57.0104 37.3603 56.8654 37.5044 56.6722 37.5044C56.4789 37.5044 56.334 37.3603 56.334 37.1682C56.334 36.9761 56.4789 36.832 56.6722 36.832C56.8654 36.832 57.0104 36.9761 57.0104 37.1682Z",
    fill: "url(#paint175_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 35.3967C57.0104 35.5888 56.8654 35.7329 56.6722 35.7329C56.4789 35.7329 56.334 35.5888 56.334 35.3967C56.334 35.2046 56.4789 35.0605 56.6722 35.0605C56.8654 35.0605 57.0104 35.2046 57.0104 35.3967Z",
    fill: "url(#paint176_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 33.6194C57.0104 33.8115 56.8654 33.9555 56.6722 33.9555C56.4789 33.9555 56.334 33.8115 56.334 33.6194C56.334 33.4273 56.4789 33.2832 56.6722 33.2832C56.8654 33.2832 57.0104 33.4273 57.0104 33.6194Z",
    fill: "url(#paint177_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 31.8378C57.0104 32.0299 56.8654 32.174 56.6722 32.174C56.4789 32.174 56.334 32.0299 56.334 31.8378C56.334 31.6457 56.4789 31.5016 56.6722 31.5016C56.8654 31.4536 57.0104 31.6457 57.0104 31.8378Z",
    fill: "url(#paint178_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 30.0119C57.0104 30.204 56.8654 30.3481 56.6722 30.3481C56.4789 30.3481 56.334 30.204 56.334 30.0119C56.334 29.8199 56.4789 29.6758 56.6722 29.6758C56.8654 29.6758 57.0104 29.8199 57.0104 30.0119Z",
    fill: "url(#paint179_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 28.2405C57.0104 28.4326 56.8654 28.5766 56.6722 28.5766C56.4789 28.5766 56.334 28.4326 56.334 28.2405C56.334 28.0484 56.4789 27.9043 56.6722 27.9043C56.8654 27.9043 57.0104 28.0484 57.0104 28.2405Z",
    fill: "url(#paint180_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 26.4631C57.0104 26.6552 56.8654 26.7993 56.6722 26.7993C56.4789 26.7993 56.334 26.6552 56.334 26.4631C56.334 26.271 56.4789 26.127 56.6722 26.127C56.8654 26.127 57.0104 26.271 57.0104 26.4631Z",
    fill: "url(#paint181_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0104 24.6838C57.0104 24.8759 56.8654 25.02 56.6722 25.02C56.4789 25.02 56.334 24.8759 56.334 24.6838C56.334 24.4917 56.4789 24.3477 56.6722 24.3477C56.8654 24.3477 57.0104 24.4917 57.0104 24.6838Z",
    fill: "url(#paint182_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.0099 49.5612C56.8167 49.5132 56.6235 49.5132 56.4785 49.4652C56.5268 49.4172 56.6235 49.3691 56.7201 49.3691C56.8167 49.3691 56.9616 49.4652 57.0099 49.5612Z",
    fill: "url(#paint183_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.3284 48.2661C59.5152 48.2661 59.6666 48.1156 59.6666 47.9299C59.6666 47.7443 59.5152 47.5938 59.3284 47.5938C59.1416 47.5938 58.9902 47.7443 58.9902 47.9299C58.9902 48.1156 59.1416 48.2661 59.3284 48.2661Z",
    fill: "url(#paint184_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 46.1057C59.7154 46.2978 59.5705 46.4419 59.3772 46.4419C59.184 46.4419 59.0391 46.2978 59.0391 46.1057C59.0391 45.9136 59.184 45.7695 59.3772 45.7695C59.5222 45.7695 59.7154 45.9136 59.7154 46.1057Z",
    fill: "url(#paint185_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 44.3284C59.7154 44.5205 59.5705 44.6645 59.3772 44.6645C59.184 44.6645 59.0391 44.5205 59.0391 44.3284C59.0391 44.1363 59.184 43.9922 59.3772 43.9922C59.5222 43.9922 59.7154 44.1363 59.7154 44.3284Z",
    fill: "url(#paint186_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 42.5491C59.7154 42.7412 59.5705 42.8852 59.3772 42.8852C59.184 42.8852 59.0391 42.7412 59.0391 42.5491C59.0391 42.357 59.184 42.2129 59.3772 42.2129C59.5222 42.2129 59.7154 42.357 59.7154 42.5491Z",
    fill: "url(#paint187_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 40.7756C59.7154 40.9677 59.5705 41.1118 59.3772 41.1118C59.184 41.1118 59.0391 40.9677 59.0391 40.7756C59.0391 40.5835 59.184 40.4395 59.3772 40.4395C59.5222 40.4395 59.7154 40.5835 59.7154 40.7756Z",
    fill: "url(#paint188_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 38.9495C59.7154 39.1416 59.5705 39.2856 59.3772 39.2856C59.184 39.2856 59.0391 39.1416 59.0391 38.9495C59.0391 38.7574 59.184 38.6133 59.3772 38.6133C59.5222 38.6133 59.7154 38.7574 59.7154 38.9495Z",
    fill: "url(#paint189_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.3284 37.5044C59.5152 37.5044 59.6666 37.3539 59.6666 37.1682C59.6666 36.9825 59.5152 36.832 59.3284 36.832C59.1416 36.832 58.9902 36.9825 58.9902 37.1682C58.9902 37.3539 59.1416 37.5044 59.3284 37.5044Z",
    fill: "url(#paint190_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 35.3967C59.7154 35.5888 59.5705 35.7329 59.3772 35.7329C59.184 35.7329 59.0391 35.5888 59.0391 35.3967C59.0391 35.2046 59.184 35.0605 59.3772 35.0605C59.5222 35.0605 59.7154 35.2046 59.7154 35.3967Z",
    fill: "url(#paint191_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.3284 33.9555C59.5152 33.9555 59.6666 33.805 59.6666 33.6194C59.6666 33.4337 59.5152 33.2832 59.3284 33.2832C59.1416 33.2832 58.9902 33.4337 58.9902 33.6194C58.9902 33.805 59.1416 33.9555 59.3284 33.9555Z",
    fill: "url(#paint192_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 31.8378C59.7154 32.0299 59.5705 32.174 59.3772 32.174C59.184 32.174 59.0391 32.0299 59.0391 31.8378C59.0391 31.6457 59.184 31.5016 59.3772 31.5016C59.5222 31.4536 59.7154 31.6457 59.7154 31.8378Z",
    fill: "url(#paint193_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 30.0119C59.7154 30.204 59.5705 30.3481 59.3772 30.3481C59.184 30.3481 59.0391 30.204 59.0391 30.0119C59.0391 29.8199 59.184 29.6758 59.3772 29.6758C59.5222 29.6758 59.7154 29.8199 59.7154 30.0119Z",
    fill: "url(#paint194_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.3284 28.5766C59.5152 28.5766 59.6666 28.4261 59.6666 28.2405C59.6666 28.0548 59.5152 27.9043 59.3284 27.9043C59.1416 27.9043 58.9902 28.0548 58.9902 28.2405C58.9902 28.4261 59.1416 28.5766 59.3284 28.5766Z",
    fill: "url(#paint195_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.3284 26.7993C59.5152 26.7993 59.6666 26.6488 59.6666 26.4631C59.6666 26.2775 59.5152 26.127 59.3284 26.127C59.1416 26.127 58.9902 26.2775 58.9902 26.4631C58.9902 26.6488 59.1416 26.7993 59.3284 26.7993Z",
    fill: "url(#paint196_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 24.6838C59.7154 24.8759 59.5705 25.02 59.3772 25.02C59.184 25.02 59.0391 24.8759 59.0391 24.6838C59.0391 24.4917 59.184 24.3477 59.3772 24.3477C59.5222 24.3477 59.7154 24.4917 59.7154 24.6838Z",
    fill: "url(#paint197_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.6671 22.8613C59.6671 22.9094 59.7154 22.9574 59.7154 23.0054C59.7154 23.1975 59.5705 23.3416 59.3772 23.3416C59.184 23.3416 59.0391 23.1975 59.0391 23.0054C59.0391 22.9574 59.0391 22.9094 59.0874 22.8613C59.184 22.8613 59.3289 22.8613 59.4256 22.8613C59.4739 22.8613 59.5705 22.8613 59.6671 22.8613Z",
    fill: "url(#paint198_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.7154 49.7053C59.7154 49.7533 59.7154 49.7533 59.7154 49.8014C59.6188 49.8014 59.5222 49.8014 59.4256 49.8014C59.2806 49.8014 59.184 49.8014 59.0391 49.8014C59.0391 49.7533 59.0391 49.7533 59.0391 49.7053C59.0391 49.5132 59.184 49.3691 59.3772 49.3691C59.5222 49.3691 59.7154 49.5132 59.7154 49.7053Z",
    fill: "url(#paint199_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 47.9296C62.3736 48.1217 62.2287 48.2657 62.0355 48.2657C61.8422 48.2657 61.6973 48.1217 61.6973 47.9296C61.6973 47.7375 61.8422 47.5934 62.0355 47.5934C62.2287 47.5454 62.3736 47.7375 62.3736 47.9296Z",
    fill: "url(#paint200_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 46.1057C62.3736 46.2978 62.2287 46.4419 62.0355 46.4419C61.8422 46.4419 61.6973 46.2978 61.6973 46.1057C61.6973 45.9136 61.8422 45.7695 62.0355 45.7695C62.2287 45.7695 62.3736 45.9136 62.3736 46.1057Z",
    fill: "url(#paint201_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 44.3284C62.3736 44.5205 62.2287 44.6645 62.0355 44.6645C61.8422 44.6645 61.6973 44.5205 61.6973 44.3284C61.6973 44.1363 61.8422 43.9922 62.0355 43.9922C62.2287 43.9922 62.3736 44.1363 62.3736 44.3284Z",
    fill: "url(#paint202_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 42.5491C62.3736 42.7412 62.2287 42.8852 62.0355 42.8852C61.8422 42.8852 61.6973 42.7412 61.6973 42.5491C61.6973 42.357 61.8422 42.2129 62.0355 42.2129C62.2287 42.2129 62.3736 42.357 62.3736 42.5491Z",
    fill: "url(#paint203_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 40.7756C62.3736 40.9677 62.2287 41.1118 62.0355 41.1118C61.8422 41.1118 61.6973 40.9677 61.6973 40.7756C61.6973 40.5835 61.8422 40.4395 62.0355 40.4395C62.2287 40.4395 62.3736 40.5835 62.3736 40.7756Z",
    fill: "url(#paint204_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 38.9495C62.3736 39.1416 62.2287 39.2856 62.0355 39.2856C61.8422 39.2856 61.6973 39.1416 61.6973 38.9495C61.6973 38.7574 61.8422 38.6133 62.0355 38.6133C62.2287 38.6133 62.3736 38.7574 62.3736 38.9495Z",
    fill: "url(#paint205_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 37.1682C62.3736 37.3603 62.2287 37.5044 62.0355 37.5044C61.8422 37.5044 61.6973 37.3603 61.6973 37.1682C61.6973 36.9761 61.8422 36.832 62.0355 36.832C62.2287 36.832 62.3736 36.9761 62.3736 37.1682Z",
    fill: "url(#paint206_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 35.3967C62.3736 35.5888 62.2287 35.7329 62.0355 35.7329C61.8422 35.7329 61.6973 35.5888 61.6973 35.3967C61.6973 35.2046 61.8422 35.0605 62.0355 35.0605C62.2287 35.0605 62.3736 35.2046 62.3736 35.3967Z",
    fill: "url(#paint207_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 33.6194C62.3736 33.8115 62.2287 33.9555 62.0355 33.9555C61.8422 33.9555 61.6973 33.8115 61.6973 33.6194C61.6973 33.4273 61.8422 33.2832 62.0355 33.2832C62.2287 33.2832 62.3736 33.4273 62.3736 33.6194Z",
    fill: "url(#paint208_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 31.8378C62.3736 32.0299 62.2287 32.174 62.0355 32.174C61.8422 32.174 61.6973 32.0299 61.6973 31.8378C61.6973 31.6457 61.8422 31.5016 62.0355 31.5016C62.2287 31.4536 62.3736 31.6457 62.3736 31.8378Z",
    fill: "url(#paint209_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 30.0119C62.3736 30.204 62.2287 30.3481 62.0355 30.3481C61.8422 30.3481 61.6973 30.204 61.6973 30.0119C61.6973 29.8199 61.8422 29.6758 62.0355 29.6758C62.2287 29.6758 62.3736 29.8199 62.3736 30.0119Z",
    fill: "url(#paint210_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 28.2405C62.3736 28.4326 62.2287 28.5766 62.0355 28.5766C61.8422 28.5766 61.6973 28.4326 61.6973 28.2405C61.6973 28.0484 61.8422 27.9043 62.0355 27.9043C62.2287 27.9043 62.3736 28.0484 62.3736 28.2405Z",
    fill: "url(#paint211_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 26.4631C62.3736 26.6552 62.2287 26.7993 62.0355 26.7993C61.8422 26.7993 61.6973 26.6552 61.6973 26.4631C61.6973 26.271 61.8422 26.127 62.0355 26.127C62.2287 26.127 62.3736 26.271 62.3736 26.4631Z",
    fill: "url(#paint212_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3736 24.6838C62.3736 24.8759 62.2287 25.02 62.0355 25.02C61.8422 25.02 61.6973 24.8759 61.6973 24.6838C61.6973 24.4917 61.8422 24.3477 62.0355 24.3477C62.2287 24.3477 62.3736 24.4917 62.3736 24.6838Z",
    fill: "url(#paint213_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.0355 49.3691C62.1321 49.3691 62.2287 49.4172 62.277 49.4652C62.0838 49.5132 61.8905 49.5612 61.6973 49.5612C61.7456 49.4652 61.8905 49.3691 62.0355 49.3691Z",
    fill: "url(#paint214_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M61.6973 23.0527C61.8905 23.1008 62.1321 23.1488 62.3253 23.1968C62.277 23.2929 62.1804 23.3409 62.0354 23.3409C61.8422 23.3409 61.6973 23.2448 61.6973 23.0527Z",
    fill: "url(#paint215_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M64.6917 48.2661C64.8785 48.2661 65.0299 48.1156 65.0299 47.9299C65.0299 47.7443 64.8785 47.5938 64.6917 47.5938C64.5049 47.5938 64.3535 47.7443 64.3535 47.9299C64.3535 48.1156 64.5049 48.2661 64.6917 48.2661Z",
    fill: "url(#paint216_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.0299 46.1057C65.0299 46.2978 64.8849 46.4419 64.6917 46.4419C64.4985 46.4419 64.3535 46.2978 64.3535 46.1057C64.3535 45.9136 64.4985 45.7695 64.6917 45.7695C64.8849 45.7695 65.0299 45.9136 65.0299 46.1057Z",
    fill: "url(#paint217_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.0299 44.3284C65.0299 44.5205 64.8849 44.6645 64.6917 44.6645C64.4985 44.6645 64.3535 44.5205 64.3535 44.3284C64.3535 44.1363 64.4985 43.9922 64.6917 43.9922C64.8849 43.9922 65.0299 44.1363 65.0299 44.3284Z",
    fill: "url(#paint218_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.0299 42.5493C65.0299 42.7414 64.8849 42.8855 64.6917 42.8855C64.4985 42.8855 64.3535 42.7414 64.3535 42.5493C64.3535 42.3572 64.4985 42.2131 64.6917 42.2131C64.8849 42.2131 65.0299 42.3572 65.0299 42.5493Z",
    fill: "url(#paint219_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.0299 40.7756C65.0299 40.9677 64.8849 41.1118 64.6917 41.1118C64.4985 41.1118 64.3535 40.9677 64.3535 40.7756C64.3535 40.5835 64.4985 40.4395 64.6917 40.4395C64.8849 40.4395 65.0299 40.5835 65.0299 40.7756Z",
    fill: "url(#paint220_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.0299 38.9495C65.0299 39.1416 64.8849 39.2856 64.6917 39.2856C64.4985 39.2856 64.3535 39.1416 64.3535 38.9495C64.3535 38.7574 64.4985 38.6133 64.6917 38.6133C64.8849 38.6133 65.0299 38.7574 65.0299 38.9495Z",
    fill: "url(#paint221_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M64.6917 37.5044C64.8785 37.5044 65.0299 37.3539 65.0299 37.1682C65.0299 36.9825 64.8785 36.832 64.6917 36.832C64.5049 36.832 64.3535 36.9825 64.3535 37.1682C64.3535 37.3539 64.5049 37.5044 64.6917 37.5044Z",
    fill: "url(#paint222_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.0299 35.3967C65.0299 35.5888 64.8849 35.7329 64.6917 35.7329C64.4985 35.7329 64.3535 35.5888 64.3535 35.3967C64.3535 35.2046 64.4985 35.0605 64.6917 35.0605C64.8849 35.0605 65.0299 35.2046 65.0299 35.3967Z",
    fill: "url(#paint223_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M64.6917 33.9555C64.8785 33.9555 65.0299 33.805 65.0299 33.6194C65.0299 33.4337 64.8785 33.2832 64.6917 33.2832C64.5049 33.2832 64.3535 33.4337 64.3535 33.6194C64.3535 33.805 64.5049 33.9555 64.6917 33.9555Z",
    fill: "url(#paint224_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.0299 31.838C65.0299 32.0301 64.8849 32.1742 64.6917 32.1742C64.4985 32.1742 64.3535 32.0301 64.3535 31.838C64.3535 31.6459 64.4985 31.5018 64.6917 31.5018C64.8849 31.4538 65.0299 31.6459 65.0299 31.838Z",
    fill: "url(#paint225_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.0299 30.0119C65.0299 30.204 64.8849 30.3481 64.6917 30.3481C64.4985 30.3481 64.3535 30.204 64.3535 30.0119C64.3535 29.8199 64.4985 29.6758 64.6917 29.6758C64.8849 29.6758 65.0299 29.8199 65.0299 30.0119Z",
    fill: "url(#paint226_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M64.6917 28.5766C64.8785 28.5766 65.0299 28.4261 65.0299 28.2405C65.0299 28.0548 64.8785 27.9043 64.6917 27.9043C64.5049 27.9043 64.3535 28.0548 64.3535 28.2405C64.3535 28.4261 64.5049 28.5766 64.6917 28.5766Z",
    fill: "url(#paint227_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M64.6917 26.7994C64.8785 26.7994 65.0299 26.6489 65.0299 26.4632C65.0299 26.2776 64.8785 26.1271 64.6917 26.1271C64.5049 26.1271 64.3535 26.2776 64.3535 26.4632C64.3535 26.6489 64.5049 26.7994 64.6917 26.7994Z",
    fill: "url(#paint228_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.0299 24.6836C65.0299 24.8757 64.8849 25.0198 64.6917 25.0198C64.4985 25.0198 64.3535 24.8757 64.3535 24.6836C64.3535 24.4915 64.4985 24.3474 64.6917 24.3474C64.8849 24.3474 65.0299 24.4915 65.0299 24.6836Z",
    fill: "url(#paint229_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 46.1057C67.735 46.2978 67.59 46.4419 67.3968 46.4419C67.2035 46.4419 67.0586 46.2978 67.0586 46.1057C67.0586 45.9136 67.2035 45.7695 67.3968 45.7695C67.5417 45.7695 67.735 45.9136 67.735 46.1057Z",
    fill: "url(#paint230_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 44.3284C67.735 44.5205 67.59 44.6645 67.3968 44.6645C67.2035 44.6645 67.0586 44.5205 67.0586 44.3284C67.0586 44.1363 67.2035 43.9922 67.3968 43.9922C67.5417 43.9922 67.735 44.1363 67.735 44.3284Z",
    fill: "url(#paint231_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 42.5491C67.735 42.7412 67.59 42.8852 67.3968 42.8852C67.2035 42.8852 67.0586 42.7412 67.0586 42.5491C67.0586 42.357 67.2035 42.2129 67.3968 42.2129C67.5417 42.2129 67.735 42.357 67.735 42.5491Z",
    fill: "url(#paint232_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 40.7756C67.735 40.9677 67.59 41.1118 67.3968 41.1118C67.2035 41.1118 67.0586 40.9677 67.0586 40.7756C67.0586 40.5835 67.2035 40.4395 67.3968 40.4395C67.5417 40.4395 67.735 40.5835 67.735 40.7756Z",
    fill: "url(#paint233_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 38.9495C67.735 39.1416 67.59 39.2856 67.3968 39.2856C67.2035 39.2856 67.0586 39.1416 67.0586 38.9495C67.0586 38.7574 67.2035 38.6133 67.3968 38.6133C67.5417 38.6133 67.735 38.7574 67.735 38.9495Z",
    fill: "url(#paint234_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 37.1682C67.735 37.3603 67.59 37.5044 67.3968 37.5044C67.2035 37.5044 67.0586 37.3603 67.0586 37.1682C67.0586 36.9761 67.2035 36.832 67.3968 36.832C67.5417 36.832 67.735 36.9761 67.735 37.1682Z",
    fill: "url(#paint235_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 35.3967C67.735 35.5888 67.59 35.7329 67.3968 35.7329C67.2035 35.7329 67.0586 35.5888 67.0586 35.3967C67.0586 35.2046 67.2035 35.0605 67.3968 35.0605C67.5417 35.0605 67.735 35.2046 67.735 35.3967Z",
    fill: "url(#paint236_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 33.6194C67.735 33.8115 67.59 33.9555 67.3968 33.9555C67.2035 33.9555 67.0586 33.8115 67.0586 33.6194C67.0586 33.4273 67.2035 33.2832 67.3968 33.2832C67.5417 33.2832 67.735 33.4273 67.735 33.6194Z",
    fill: "url(#paint237_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 31.8378C67.735 32.0299 67.59 32.174 67.3968 32.174C67.2035 32.174 67.0586 32.0299 67.0586 31.8378C67.0586 31.6457 67.2035 31.5016 67.3968 31.5016C67.5417 31.4536 67.735 31.6457 67.735 31.8378Z",
    fill: "url(#paint238_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 30.0119C67.735 30.204 67.59 30.3481 67.3968 30.3481C67.2035 30.3481 67.0586 30.204 67.0586 30.0119C67.0586 29.8199 67.2035 29.6758 67.3968 29.6758C67.5417 29.6758 67.735 29.8199 67.735 30.0119Z",
    fill: "url(#paint239_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 28.2405C67.735 28.4326 67.59 28.5766 67.3968 28.5766C67.2035 28.5766 67.0586 28.4326 67.0586 28.2405C67.0586 28.0484 67.2035 27.9043 67.3968 27.9043C67.5417 27.9043 67.735 28.0484 67.735 28.2405Z",
    fill: "url(#paint240_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.735 26.4631C67.735 26.6552 67.59 26.7993 67.3968 26.7993C67.2035 26.7993 67.0586 26.6552 67.0586 26.4631C67.0586 26.271 67.2035 26.127 67.3968 26.127C67.5417 26.127 67.735 26.271 67.735 26.4631Z",
    fill: "url(#paint241_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.3932 42.5491C70.3932 42.7412 70.2482 42.8852 70.055 42.8852C69.8617 42.8852 69.7168 42.7412 69.7168 42.5491C69.7168 42.357 69.8617 42.2129 70.055 42.2129C70.2482 42.2129 70.3932 42.357 70.3932 42.5491Z",
    fill: "url(#paint242_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.3932 40.7756C70.3932 40.9677 70.2482 41.1118 70.055 41.1118C69.8617 41.1118 69.7168 40.9677 69.7168 40.7756C69.7168 40.5835 69.8617 40.4395 70.055 40.4395C70.2482 40.4395 70.3932 40.5835 70.3932 40.7756Z",
    fill: "url(#paint243_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.3932 38.9495C70.3932 39.1416 70.2482 39.2856 70.055 39.2856C69.8617 39.2856 69.7168 39.1416 69.7168 38.9495C69.7168 38.7574 69.8617 38.6133 70.055 38.6133C70.2482 38.6133 70.3932 38.7574 70.3932 38.9495Z",
    fill: "url(#paint244_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.3932 37.1682C70.3932 37.3603 70.2482 37.5044 70.055 37.5044C69.8617 37.5044 69.7168 37.3603 69.7168 37.1682C69.7168 36.9761 69.8617 36.832 70.055 36.832C70.2482 36.832 70.3932 36.9761 70.3932 37.1682Z",
    fill: "url(#paint245_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.3932 35.3967C70.3932 35.5888 70.2482 35.7329 70.055 35.7329C69.8617 35.7329 69.7168 35.5888 69.7168 35.3967C69.7168 35.2046 69.8617 35.0605 70.055 35.0605C70.2482 35.0605 70.3932 35.2046 70.3932 35.3967Z",
    fill: "url(#paint246_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.3932 33.6194C70.3932 33.8115 70.2482 33.9555 70.055 33.9555C69.8617 33.9555 69.7168 33.8115 69.7168 33.6194C69.7168 33.4273 69.8617 33.2832 70.055 33.2832C70.2482 33.2832 70.3932 33.4273 70.3932 33.6194Z",
    fill: "url(#paint247_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.3932 31.8378C70.3932 32.0299 70.2482 32.174 70.055 32.174C69.8617 32.174 69.7168 32.0299 69.7168 31.8378C69.7168 31.6457 69.8617 31.5016 70.055 31.5016C70.2482 31.4536 70.3932 31.6457 70.3932 31.8378Z",
    fill: "url(#paint248_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.3932 30.0119C70.3932 30.204 70.2482 30.3481 70.055 30.3481C69.8617 30.3481 69.7168 30.204 69.7168 30.0119C69.7168 29.8199 69.8617 29.6758 70.055 29.6758C70.2482 29.6758 70.3932 29.8199 70.3932 30.0119Z",
    fill: "url(#paint249_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M69.7168 28.2405C69.7168 28.0964 69.8134 27.9523 69.9584 27.9043C70.1033 28.0484 70.2482 28.2405 70.3449 28.4326C70.2965 28.5286 70.1999 28.5766 70.055 28.5766C69.8617 28.5766 69.7168 28.4326 69.7168 28.2405Z",
    fill: "url(#paint250_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.3449 44.1843C70.2482 44.3284 70.1033 44.5205 70.0067 44.6645C69.8134 44.6645 69.7168 44.5205 69.7168 44.3284C69.7168 44.1363 69.8617 43.9922 70.055 43.9922C70.1999 43.9922 70.2965 44.0882 70.3449 44.1843Z",
    fill: "url(#paint251_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M72.1309 33.6163C72.1309 33.4722 72.2275 33.3761 72.3241 33.3281C72.3724 33.5682 72.4207 33.7603 72.469 34.0005C72.2758 33.9524 72.1309 33.8084 72.1309 33.6163Z",
    fill: "url(#paint252_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M72.469 38.6133C72.4207 38.8534 72.3724 39.0455 72.3241 39.2856C72.1792 39.2376 72.1309 39.0935 72.1309 38.9495C72.1309 38.7574 72.2758 38.6133 72.469 38.6133Z",
    fill: "url(#paint253_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M72.1309 35.3967C72.1309 35.2046 72.2758 35.0605 72.469 35.0605C72.5174 35.0605 72.5657 35.0605 72.614 35.1086C72.614 35.3007 72.6623 35.4928 72.6623 35.6849C72.614 35.7329 72.5657 35.7329 72.469 35.7329C72.2758 35.7329 72.1309 35.5888 72.1309 35.3967Z",
    fill: "url(#paint254_linear_1_421)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M72.6623 36.8801C72.6623 37.0722 72.6623 37.2643 72.614 37.4563C72.5657 37.4563 72.5174 37.5044 72.469 37.5044C72.2758 37.5044 72.1309 37.3603 72.1309 37.1682C72.1309 36.9761 72.2758 36.832 72.469 36.832C72.5174 36.832 72.614 36.8801 72.6623 36.8801Z",
    fill: "url(#paint255_linear_1_421)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2789 50.043H38.5482H27.5098V54.6593C27.5098 61.8268 35.3943 66.1276 35.3943 66.1276C35.3943 66.1276 38.5911 64.3833 40.9135 61.2658C43.2362 64.3834 46.4331 66.1278 46.4331 66.1278C46.4331 66.1278 54.3176 61.8268 54.3176 54.6594V50.0431H43.2789V50.043ZM35.4025 59.4381C34.3063 58.3839 33.2148 56.9807 32.9414 55.4062H37.8576C37.5859 56.985 36.4992 58.3852 35.4025 59.4381ZM43.9766 55.4062C44.25 56.9807 45.3416 58.3839 46.4378 59.4381C47.5346 58.3852 48.6211 56.985 48.8929 55.4062H43.9766Z",
    fill: "#43A7D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7912 28.9459V39.9932L11.4297 45.3548V55.4011H32.876V18.2228L16.7912 28.9459Z",
    fill: "#EAE2FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0438 39.9931V28.9458L48.959 18.2227V55.401H70.4053V45.3546L65.0438 39.9931Z",
    fill: "#EAE2FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3197 55.4029V19.4969C54.3197 7.31081 40.9157 0 40.9157 0C40.9157 0 27.5117 7.31081 27.5117 19.4969V55.4029H54.3197Z",
    fill: "#FBFBFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.276 16.0902C46.276 13.1291 43.8753 10.7285 40.9144 10.7285V10.7285C37.9536 10.7285 35.5527 13.1291 35.5527 16.0902H46.276Z",
    fill: "#8D4FFF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.9144,
    cy: 35.7503,
    rx: 5.36164,
    ry: 7.14872,
    fill: "#8D4FFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.5117,
    y: 50.0371,
    width: 26.8079,
    height: 5.36164,
    fill: "url(#paint256_linear_1_421)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_421",
    x1: 56.4004,
    y1: 23.2219,
    x2: 57.0119,
    y2: 23.2219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_421",
    x1: 59.0089,
    y1: 23.1196,
    x2: 59.6958,
    y2: 23.1196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_421",
    x1: 61.6948,
    y1: 23.2169,
    x2: 62.3188,
    y2: 23.2169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_421",
    x1: 53.6595,
    y1: 24.6661,
    x2: 54.3464,
    y2: 24.6661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_421",
    x1: 56.337,
    y1: 24.6661,
    x2: 57.0198,
    y2: 24.6661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_421",
    x1: 59.0089,
    y1: 24.6661,
    x2: 59.6958,
    y2: 24.6661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_421",
    x1: 61.6863,
    y1: 24.6661,
    x2: 62.3691,
    y2: 24.6661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_421",
    x1: 64.3578,
    y1: 24.6658,
    x2: 65.0446,
    y2: 24.6658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_421",
    x1: 50.9877,
    y1: 26.4567,
    x2: 51.6704,
    y2: 26.4567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_421",
    x1: 53.6595,
    y1: 26.4567,
    x2: 54.3464,
    y2: 26.4567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_421",
    x1: 56.337,
    y1: 26.4567,
    x2: 57.0198,
    y2: 26.4567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_421",
    x1: 59.0084,
    y1: 26.4567,
    x2: 59.6953,
    y2: 26.4567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_421",
    x1: 61.6863,
    y1: 26.4567,
    x2: 62.3691,
    y2: 26.4567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_421",
    x1: 64.3578,
    y1: 26.4569,
    x2: 65.0446,
    y2: 26.4569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_421",
    x1: 67.0338,
    y1: 26.4567,
    x2: 67.7165,
    y2: 26.4567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_421",
    x1: 48.4033,
    y1: 28.263,
    x2: 48.9981,
    y2: 28.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_421",
    x1: 50.9877,
    y1: 28.2434,
    x2: 51.6704,
    y2: 28.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_421",
    x1: 53.6595,
    y1: 28.2434,
    x2: 54.3464,
    y2: 28.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_421",
    x1: 56.337,
    y1: 28.2434,
    x2: 57.0198,
    y2: 28.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_421",
    x1: 59.0084,
    y1: 28.2434,
    x2: 59.6953,
    y2: 28.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_421",
    x1: 61.6863,
    y1: 28.2434,
    x2: 62.3691,
    y2: 28.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_421",
    x1: 64.3578,
    y1: 28.2434,
    x2: 65.0446,
    y2: 28.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_421",
    x1: 67.0338,
    y1: 28.2434,
    x2: 67.7165,
    y2: 28.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_421",
    x1: 69.7071,
    y1: 28.2517,
    x2: 70.3396,
    y2: 28.2517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1_421",
    x1: 48.3121,
    y1: 30.0262,
    x2: 48.999,
    y2: 30.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1_421",
    x1: 50.9877,
    y1: 30.0262,
    x2: 51.6704,
    y2: 30.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1_421",
    x1: 53.6595,
    y1: 30.0262,
    x2: 54.3464,
    y2: 30.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1_421",
    x1: 56.337,
    y1: 30.0262,
    x2: 57.0198,
    y2: 30.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1_421",
    x1: 59.0089,
    y1: 30.0262,
    x2: 59.6958,
    y2: 30.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1_421",
    x1: 61.6863,
    y1: 30.0262,
    x2: 62.3691,
    y2: 30.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1_421",
    x1: 64.3578,
    y1: 30.0262,
    x2: 65.0446,
    y2: 30.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1_421",
    x1: 67.0338,
    y1: 30.0262,
    x2: 67.7165,
    y2: 30.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1_421",
    x1: 69.7071,
    y1: 30.0262,
    x2: 70.394,
    y2: 30.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1_421",
    x1: 48.3121,
    y1: 31.8154,
    x2: 48.999,
    y2: 31.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1_421",
    x1: 50.9877,
    y1: 31.8154,
    x2: 51.6704,
    y2: 31.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1_421",
    x1: 53.6595,
    y1: 31.8154,
    x2: 54.3464,
    y2: 31.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1_421",
    x1: 56.337,
    y1: 31.8154,
    x2: 57.0198,
    y2: 31.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1_421",
    x1: 59.0089,
    y1: 31.8154,
    x2: 59.6958,
    y2: 31.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1_421",
    x1: 61.6863,
    y1: 31.8154,
    x2: 62.3691,
    y2: 31.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1_421",
    x1: 64.3578,
    y1: 31.8156,
    x2: 65.0446,
    y2: 31.8156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1_421",
    x1: 67.0338,
    y1: 31.8154,
    x2: 67.7165,
    y2: 31.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1_421",
    x1: 69.7071,
    y1: 31.8154,
    x2: 70.394,
    y2: 31.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1_421",
    x1: 46.2217,
    y1: 33.6371,
    x2: 46.4689,
    y2: 33.6371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1_421",
    x1: 48.3121,
    y1: 33.6062,
    x2: 48.999,
    y2: 33.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1_421",
    x1: 50.9877,
    y1: 33.6062,
    x2: 51.6704,
    y2: 33.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1_421",
    x1: 53.6595,
    y1: 33.6062,
    x2: 54.3464,
    y2: 33.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1_421",
    x1: 56.337,
    y1: 33.6062,
    x2: 57.0198,
    y2: 33.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1_421",
    x1: 59.0084,
    y1: 33.6062,
    x2: 59.6953,
    y2: 33.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1_421",
    x1: 61.6863,
    y1: 33.6062,
    x2: 62.3691,
    y2: 33.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1_421",
    x1: 64.3578,
    y1: 33.6062,
    x2: 65.0446,
    y2: 33.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1_421",
    x1: 67.0338,
    y1: 33.6062,
    x2: 67.7165,
    y2: 33.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1_421",
    x1: 69.7071,
    y1: 33.6062,
    x2: 70.394,
    y2: 33.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1_421",
    x1: 72.1196,
    y1: 33.6197,
    x2: 72.4463,
    y2: 33.6197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1_421",
    x1: 46.0206,
    y1: 35.3949,
    x2: 46.4687,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1_421",
    x1: 48.3121,
    y1: 35.3949,
    x2: 48.999,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1_421",
    x1: 50.9877,
    y1: 35.3949,
    x2: 51.6704,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1_421",
    x1: 53.6595,
    y1: 35.3949,
    x2: 54.3464,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1_421",
    x1: 56.337,
    y1: 35.3949,
    x2: 57.0198,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1_421",
    x1: 59.0089,
    y1: 35.3949,
    x2: 59.6958,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1_421",
    x1: 61.6863,
    y1: 35.3949,
    x2: 62.3691,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1_421",
    x1: 64.3578,
    y1: 35.3949,
    x2: 65.0446,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1_421",
    x1: 67.0338,
    y1: 35.3949,
    x2: 67.7165,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1_421",
    x1: 69.7071,
    y1: 35.3949,
    x2: 70.394,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1_421",
    x1: 72.1182,
    y1: 35.3949,
    x2: 72.6417,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1_421",
    x1: 46.0206,
    y1: 37.1778,
    x2: 46.4687,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1_421",
    x1: 48.3121,
    y1: 37.1778,
    x2: 48.999,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1_421",
    x1: 50.9877,
    y1: 37.1778,
    x2: 51.6704,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1_421",
    x1: 53.6595,
    y1: 37.1778,
    x2: 54.3464,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1_421",
    x1: 56.337,
    y1: 37.1778,
    x2: 57.0198,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1_421",
    x1: 59.0084,
    y1: 37.1778,
    x2: 59.6953,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1_421",
    x1: 61.6863,
    y1: 37.1778,
    x2: 62.3691,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1_421",
    x1: 64.3578,
    y1: 37.1778,
    x2: 65.0446,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1_421",
    x1: 67.0338,
    y1: 37.1778,
    x2: 67.7165,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1_421",
    x1: 69.7071,
    y1: 37.1778,
    x2: 70.394,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1_421",
    x1: 72.1182,
    y1: 37.1778,
    x2: 72.6459,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1_421",
    x1: 46.2045,
    y1: 38.9421,
    x2: 46.4683,
    y2: 38.9421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1_421",
    x1: 48.3121,
    y1: 38.9703,
    x2: 48.999,
    y2: 38.9703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1_421",
    x1: 50.9877,
    y1: 38.9703,
    x2: 51.6704,
    y2: 38.9703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1_421",
    x1: 53.6595,
    y1: 38.9703,
    x2: 54.3464,
    y2: 38.9703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1_421",
    x1: 56.337,
    y1: 38.9703,
    x2: 57.0198,
    y2: 38.9703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1_421",
    x1: 59.0089,
    y1: 38.9703,
    x2: 59.6958,
    y2: 38.9703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1_421",
    x1: 61.6863,
    y1: 38.9703,
    x2: 62.3691,
    y2: 38.9703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1_421",
    x1: 64.3578,
    y1: 38.9703,
    x2: 65.0446,
    y2: 38.9703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1_421",
    x1: 67.0338,
    y1: 38.9703,
    x2: 67.7165,
    y2: 38.9703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1_421",
    x1: 69.7071,
    y1: 38.9703,
    x2: 70.394,
    y2: 38.9703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1_421",
    x1: 72.1182,
    y1: 38.9579,
    x2: 72.4575,
    y2: 38.9579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1_421",
    x1: 48.3121,
    y1: 40.7578,
    x2: 48.999,
    y2: 40.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1_421",
    x1: 50.9877,
    y1: 40.7578,
    x2: 51.6704,
    y2: 40.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1_421",
    x1: 53.6595,
    y1: 40.7578,
    x2: 54.3464,
    y2: 40.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_1_421",
    x1: 56.337,
    y1: 40.7578,
    x2: 57.0198,
    y2: 40.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_1_421",
    x1: 59.0089,
    y1: 40.7578,
    x2: 59.6958,
    y2: 40.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_1_421",
    x1: 61.6863,
    y1: 40.7578,
    x2: 62.3691,
    y2: 40.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_1_421",
    x1: 64.3578,
    y1: 40.7578,
    x2: 65.0446,
    y2: 40.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_1_421",
    x1: 67.0338,
    y1: 40.7578,
    x2: 67.7165,
    y2: 40.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_1_421",
    x1: 69.7071,
    y1: 40.7578,
    x2: 70.394,
    y2: 40.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_1_421",
    x1: 48.3121,
    y1: 42.5425,
    x2: 48.999,
    y2: 42.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_1_421",
    x1: 50.9877,
    y1: 42.5425,
    x2: 51.6704,
    y2: 42.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_1_421",
    x1: 53.6595,
    y1: 42.5425,
    x2: 54.3464,
    y2: 42.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_1_421",
    x1: 56.337,
    y1: 42.5425,
    x2: 57.0198,
    y2: 42.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_1_421",
    x1: 59.0089,
    y1: 42.5425,
    x2: 59.6958,
    y2: 42.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_1_421",
    x1: 61.6863,
    y1: 42.5425,
    x2: 62.3691,
    y2: 42.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_1_421",
    x1: 64.3578,
    y1: 42.5428,
    x2: 65.0446,
    y2: 42.5428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_1_421",
    x1: 67.0338,
    y1: 42.5425,
    x2: 67.7165,
    y2: 42.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_1_421",
    x1: 69.7071,
    y1: 42.5425,
    x2: 70.394,
    y2: 42.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_1_421",
    x1: 48.3735,
    y1: 44.3227,
    x2: 48.9976,
    y2: 44.3227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_1_421",
    x1: 50.9877,
    y1: 44.3332,
    x2: 51.6704,
    y2: 44.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_1_421",
    x1: 53.6595,
    y1: 44.3332,
    x2: 54.3464,
    y2: 44.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_1_421",
    x1: 56.337,
    y1: 44.3332,
    x2: 57.0198,
    y2: 44.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_1_421",
    x1: 59.0089,
    y1: 44.3332,
    x2: 59.6958,
    y2: 44.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_1_421",
    x1: 61.6863,
    y1: 44.3332,
    x2: 62.3691,
    y2: 44.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_1_421",
    x1: 64.3578,
    y1: 44.3332,
    x2: 65.0446,
    y2: 44.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_1_421",
    x1: 67.0338,
    y1: 44.3332,
    x2: 67.7165,
    y2: 44.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_1_421",
    x1: 69.7071,
    y1: 44.3311,
    x2: 70.3689,
    y2: 44.3311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_1_421",
    x1: 50.9877,
    y1: 46.1198,
    x2: 51.6704,
    y2: 46.1198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_1_421",
    x1: 53.6595,
    y1: 46.1198,
    x2: 54.3464,
    y2: 46.1198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_1_421",
    x1: 56.337,
    y1: 46.1198,
    x2: 57.0198,
    y2: 46.1198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_1_421",
    x1: 59.0089,
    y1: 46.1198,
    x2: 59.6958,
    y2: 46.1198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_1_421",
    x1: 61.6863,
    y1: 46.1198,
    x2: 62.3691,
    y2: 46.1198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_1_421",
    x1: 64.3578,
    y1: 46.1198,
    x2: 65.0446,
    y2: 46.1198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_1_421",
    x1: 67.0338,
    y1: 46.1198,
    x2: 67.7165,
    y2: 46.1198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_1_421",
    x1: 53.6595,
    y1: 47.9073,
    x2: 54.3464,
    y2: 47.9073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_1_421",
    x1: 56.337,
    y1: 47.907,
    x2: 57.0198,
    y2: 47.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_1_421",
    x1: 59.0084,
    y1: 47.9073,
    x2: 59.6953,
    y2: 47.9073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_1_421",
    x1: 61.6863,
    y1: 47.907,
    x2: 62.3691,
    y2: 47.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_1_421",
    x1: 64.3578,
    y1: 47.9073,
    x2: 65.0446,
    y2: 47.9073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_1_421",
    x1: 56.4413,
    y1: 49.4588,
    x2: 56.9942,
    y2: 49.4588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_1_421",
    x1: 59.0089,
    y1: 49.565,
    x2: 59.6958,
    y2: 49.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_1_421",
    x1: 61.7073,
    y1: 49.4682,
    x2: 62.277,
    y2: 49.4682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_1_421",
    x1: 46.0206,
    y1: 37.1778,
    x2: 46.4687,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_1_421",
    x1: 46.0206,
    y1: 35.3949,
    x2: 46.4687,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_1_421",
    x1: 46.2045,
    y1: 38.9421,
    x2: 46.4683,
    y2: 38.9421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_1_421",
    x1: 46.2217,
    y1: 33.6343,
    x2: 46.4689,
    y2: 33.6343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_1_421",
    x1: 48.3121,
    y1: 42.5425,
    x2: 48.999,
    y2: 42.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_1_421",
    x1: 48.3121,
    y1: 40.7578,
    x2: 48.999,
    y2: 40.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_1_421",
    x1: 48.3121,
    y1: 38.9703,
    x2: 48.999,
    y2: 38.9703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_1_421",
    x1: 48.3121,
    y1: 37.1778,
    x2: 48.999,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_1_421",
    x1: 48.3121,
    y1: 35.3949,
    x2: 48.999,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_1_421",
    x1: 48.3121,
    y1: 33.6062,
    x2: 48.999,
    y2: 33.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_1_421",
    x1: 48.3121,
    y1: 31.8154,
    x2: 48.999,
    y2: 31.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_1_421",
    x1: 48.3121,
    y1: 30.0262,
    x2: 48.999,
    y2: 30.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_1_421",
    x1: 48.3735,
    y1: 44.3227,
    x2: 48.9976,
    y2: 44.3227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_1_421",
    x1: 48.4033,
    y1: 28.263,
    x2: 48.9981,
    y2: 28.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_1_421",
    x1: 50.9877,
    y1: 46.1198,
    x2: 51.6704,
    y2: 46.1198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_1_421",
    x1: 50.9877,
    y1: 44.3332,
    x2: 51.6704,
    y2: 44.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_1_421",
    x1: 50.9877,
    y1: 42.5425,
    x2: 51.6704,
    y2: 42.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_1_421",
    x1: 50.9877,
    y1: 40.7578,
    x2: 51.6704,
    y2: 40.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_1_421",
    x1: 50.9877,
    y1: 38.9703,
    x2: 51.6704,
    y2: 38.9703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_1_421",
    x1: 50.9877,
    y1: 37.1778,
    x2: 51.6704,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_1_421",
    x1: 50.9877,
    y1: 35.3949,
    x2: 51.6704,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_1_421",
    x1: 50.9877,
    y1: 33.6062,
    x2: 51.6704,
    y2: 33.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_1_421",
    x1: 50.9877,
    y1: 31.8154,
    x2: 51.6704,
    y2: 31.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_1_421",
    x1: 50.9877,
    y1: 30.0262,
    x2: 51.6704,
    y2: 30.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_1_421",
    x1: 50.9877,
    y1: 28.2434,
    x2: 51.6704,
    y2: 28.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_1_421",
    x1: 50.9877,
    y1: 26.4567,
    x2: 51.6704,
    y2: 26.4567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_1_421",
    x1: 53.6595,
    y1: 47.9073,
    x2: 54.3464,
    y2: 47.9073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_1_421",
    x1: 53.6595,
    y1: 46.1198,
    x2: 54.3464,
    y2: 46.1198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_1_421",
    x1: 53.6595,
    y1: 44.3332,
    x2: 54.3464,
    y2: 44.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_1_421",
    x1: 53.6595,
    y1: 42.5425,
    x2: 54.3464,
    y2: 42.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_1_421",
    x1: 53.6595,
    y1: 40.7578,
    x2: 54.3464,
    y2: 40.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_1_421",
    x1: 53.6595,
    y1: 38.9703,
    x2: 54.3464,
    y2: 38.9703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_1_421",
    x1: 53.6595,
    y1: 37.1778,
    x2: 54.3464,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_1_421",
    x1: 53.6595,
    y1: 35.3949,
    x2: 54.3464,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_1_421",
    x1: 53.6595,
    y1: 33.6062,
    x2: 54.3464,
    y2: 33.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_1_421",
    x1: 53.6595,
    y1: 31.8154,
    x2: 54.3464,
    y2: 31.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_1_421",
    x1: 53.6595,
    y1: 30.0262,
    x2: 54.3464,
    y2: 30.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_1_421",
    x1: 53.6595,
    y1: 28.2434,
    x2: 54.3464,
    y2: 28.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_1_421",
    x1: 53.6595,
    y1: 26.4567,
    x2: 54.3464,
    y2: 26.4567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_1_421",
    x1: 53.6595,
    y1: 24.6661,
    x2: 54.3464,
    y2: 24.6661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_1_421",
    x1: 56.4004,
    y1: 23.2231,
    x2: 57.0119,
    y2: 23.2231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_1_421",
    x1: 56.337,
    y1: 47.907,
    x2: 57.0198,
    y2: 47.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_1_421",
    x1: 56.337,
    y1: 46.1198,
    x2: 57.0198,
    y2: 46.1198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_1_421",
    x1: 56.337,
    y1: 44.3332,
    x2: 57.0198,
    y2: 44.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_1_421",
    x1: 56.337,
    y1: 42.5425,
    x2: 57.0198,
    y2: 42.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_1_421",
    x1: 56.337,
    y1: 40.7578,
    x2: 57.0198,
    y2: 40.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_1_421",
    x1: 56.337,
    y1: 38.9703,
    x2: 57.0198,
    y2: 38.9703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_1_421",
    x1: 56.337,
    y1: 37.1778,
    x2: 57.0198,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_1_421",
    x1: 56.337,
    y1: 35.3949,
    x2: 57.0198,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_1_421",
    x1: 56.337,
    y1: 33.6062,
    x2: 57.0198,
    y2: 33.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_1_421",
    x1: 56.337,
    y1: 31.8154,
    x2: 57.0198,
    y2: 31.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_1_421",
    x1: 56.337,
    y1: 30.0262,
    x2: 57.0198,
    y2: 30.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_1_421",
    x1: 56.337,
    y1: 28.2434,
    x2: 57.0198,
    y2: 28.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_1_421",
    x1: 56.337,
    y1: 26.4567,
    x2: 57.0198,
    y2: 26.4567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_1_421",
    x1: 56.337,
    y1: 24.6661,
    x2: 57.0198,
    y2: 24.6661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_1_421",
    x1: 56.4413,
    y1: 49.4588,
    x2: 56.9942,
    y2: 49.4588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_1_421",
    x1: 59.0084,
    y1: 47.9073,
    x2: 59.6953,
    y2: 47.9073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_1_421",
    x1: 59.0089,
    y1: 46.1198,
    x2: 59.6958,
    y2: 46.1198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_1_421",
    x1: 59.0089,
    y1: 44.3332,
    x2: 59.6958,
    y2: 44.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_1_421",
    x1: 59.0089,
    y1: 42.5425,
    x2: 59.6958,
    y2: 42.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_1_421",
    x1: 59.0089,
    y1: 40.7578,
    x2: 59.6958,
    y2: 40.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_1_421",
    x1: 59.0089,
    y1: 38.9703,
    x2: 59.6958,
    y2: 38.9703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_1_421",
    x1: 59.0084,
    y1: 37.1778,
    x2: 59.6953,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_1_421",
    x1: 59.0089,
    y1: 35.3949,
    x2: 59.6958,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_1_421",
    x1: 59.0084,
    y1: 33.6062,
    x2: 59.6953,
    y2: 33.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_1_421",
    x1: 59.0089,
    y1: 31.8154,
    x2: 59.6958,
    y2: 31.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_1_421",
    x1: 59.0089,
    y1: 30.0262,
    x2: 59.6958,
    y2: 30.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_1_421",
    x1: 59.0084,
    y1: 28.2434,
    x2: 59.6953,
    y2: 28.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_1_421",
    x1: 59.0084,
    y1: 26.4567,
    x2: 59.6953,
    y2: 26.4567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_1_421",
    x1: 59.0089,
    y1: 24.6661,
    x2: 59.6958,
    y2: 24.6661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_1_421",
    x1: 59.0089,
    y1: 23.1196,
    x2: 59.6958,
    y2: 23.1196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_1_421",
    x1: 59.0089,
    y1: 49.565,
    x2: 59.6958,
    y2: 49.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_1_421",
    x1: 61.6863,
    y1: 47.907,
    x2: 62.3691,
    y2: 47.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_1_421",
    x1: 61.6863,
    y1: 46.1198,
    x2: 62.3691,
    y2: 46.1198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_1_421",
    x1: 61.6863,
    y1: 44.3332,
    x2: 62.3691,
    y2: 44.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_1_421",
    x1: 61.6863,
    y1: 42.5425,
    x2: 62.3691,
    y2: 42.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_1_421",
    x1: 61.6863,
    y1: 40.7578,
    x2: 62.3691,
    y2: 40.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_1_421",
    x1: 61.6863,
    y1: 38.9703,
    x2: 62.3691,
    y2: 38.9703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_1_421",
    x1: 61.6863,
    y1: 37.1778,
    x2: 62.3691,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_1_421",
    x1: 61.6863,
    y1: 35.3949,
    x2: 62.3691,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_1_421",
    x1: 61.6863,
    y1: 33.6062,
    x2: 62.3691,
    y2: 33.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_1_421",
    x1: 61.6863,
    y1: 31.8154,
    x2: 62.3691,
    y2: 31.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_1_421",
    x1: 61.6863,
    y1: 30.0262,
    x2: 62.3691,
    y2: 30.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_1_421",
    x1: 61.6863,
    y1: 28.2434,
    x2: 62.3691,
    y2: 28.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_1_421",
    x1: 61.6863,
    y1: 26.4567,
    x2: 62.3691,
    y2: 26.4567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_1_421",
    x1: 61.6863,
    y1: 24.6661,
    x2: 62.3691,
    y2: 24.6661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_1_421",
    x1: 61.7073,
    y1: 49.4651,
    x2: 62.277,
    y2: 49.4651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_1_421",
    x1: 61.6948,
    y1: 23.2169,
    x2: 62.3188,
    y2: 23.2169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_1_421",
    x1: 64.3578,
    y1: 47.9073,
    x2: 65.0446,
    y2: 47.9073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_1_421",
    x1: 64.3578,
    y1: 46.1198,
    x2: 65.0446,
    y2: 46.1198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_1_421",
    x1: 64.3578,
    y1: 44.3332,
    x2: 65.0446,
    y2: 44.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_1_421",
    x1: 64.3578,
    y1: 42.5428,
    x2: 65.0446,
    y2: 42.5428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_1_421",
    x1: 64.3578,
    y1: 40.7578,
    x2: 65.0446,
    y2: 40.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_1_421",
    x1: 64.3578,
    y1: 38.9703,
    x2: 65.0446,
    y2: 38.9703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_1_421",
    x1: 64.3578,
    y1: 37.1778,
    x2: 65.0446,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_1_421",
    x1: 64.3578,
    y1: 35.3949,
    x2: 65.0446,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_1_421",
    x1: 64.3578,
    y1: 33.6062,
    x2: 65.0446,
    y2: 33.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_1_421",
    x1: 64.3578,
    y1: 31.8156,
    x2: 65.0446,
    y2: 31.8156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_1_421",
    x1: 64.3578,
    y1: 30.0262,
    x2: 65.0446,
    y2: 30.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_1_421",
    x1: 64.3578,
    y1: 28.2434,
    x2: 65.0446,
    y2: 28.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_1_421",
    x1: 64.3578,
    y1: 26.4569,
    x2: 65.0446,
    y2: 26.4569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_1_421",
    x1: 64.3578,
    y1: 24.6658,
    x2: 65.0446,
    y2: 24.6658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_1_421",
    x1: 67.0338,
    y1: 46.1198,
    x2: 67.7165,
    y2: 46.1198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_1_421",
    x1: 67.0338,
    y1: 44.3332,
    x2: 67.7165,
    y2: 44.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_1_421",
    x1: 67.0338,
    y1: 42.5425,
    x2: 67.7165,
    y2: 42.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_1_421",
    x1: 67.0338,
    y1: 40.7578,
    x2: 67.7165,
    y2: 40.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_1_421",
    x1: 67.0338,
    y1: 38.9703,
    x2: 67.7165,
    y2: 38.9703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_1_421",
    x1: 67.0338,
    y1: 37.1778,
    x2: 67.7165,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_1_421",
    x1: 67.0338,
    y1: 35.3949,
    x2: 67.7165,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_1_421",
    x1: 67.0338,
    y1: 33.6062,
    x2: 67.7165,
    y2: 33.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_1_421",
    x1: 67.0338,
    y1: 31.8154,
    x2: 67.7165,
    y2: 31.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_1_421",
    x1: 67.0338,
    y1: 30.0262,
    x2: 67.7165,
    y2: 30.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_1_421",
    x1: 67.0338,
    y1: 28.2434,
    x2: 67.7165,
    y2: 28.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_1_421",
    x1: 67.0338,
    y1: 26.4567,
    x2: 67.7165,
    y2: 26.4567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_1_421",
    x1: 69.7071,
    y1: 42.5425,
    x2: 70.394,
    y2: 42.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_1_421",
    x1: 69.7071,
    y1: 40.7578,
    x2: 70.394,
    y2: 40.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_1_421",
    x1: 69.7071,
    y1: 38.9703,
    x2: 70.394,
    y2: 38.9703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_1_421",
    x1: 69.7071,
    y1: 37.1778,
    x2: 70.394,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_1_421",
    x1: 69.7071,
    y1: 35.3949,
    x2: 70.394,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_1_421",
    x1: 69.7071,
    y1: 33.6062,
    x2: 70.394,
    y2: 33.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_1_421",
    x1: 69.7071,
    y1: 31.8154,
    x2: 70.394,
    y2: 31.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_1_421",
    x1: 69.7071,
    y1: 30.0262,
    x2: 70.394,
    y2: 30.0262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_1_421",
    x1: 69.7071,
    y1: 28.2517,
    x2: 70.3396,
    y2: 28.2517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_1_421",
    x1: 69.7071,
    y1: 44.3311,
    x2: 70.3689,
    y2: 44.3311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_1_421",
    x1: 72.1182,
    y1: 33.6197,
    x2: 72.4448,
    y2: 33.6197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_1_421",
    x1: 72.1182,
    y1: 38.9579,
    x2: 72.4575,
    y2: 38.9579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_1_421",
    x1: 72.1182,
    y1: 35.3949,
    x2: 72.6417,
    y2: 35.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_1_421",
    x1: 72.1182,
    y1: 37.1778,
    x2: 72.6459,
    y2: 37.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_1_421",
    x1: 39.4539,
    y1: 47.9876,
    x2: 39.4938,
    y2: 49.1487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceicon2);
export default __webpack_public_path__ + "static/media/priceicon2.b3941ba7c3e3c13c7d90d436b458a866.svg";
export { ForwardRef as ReactComponent };